/**
 * Workbench 配置（工作台相关）
 * 用于首页工作台输入框的多语言
 */

export default {
    zh: {
        importLink: '链接导入',
        videoPreview: '视频预览',
        modeSelect: '模式选择',
        reselect: '重新选择',
        select: '选择',
        selectModel: '选择模型',
        openQuickSwitches: '打开快捷开关',
        quickSettings: {
            openSettings: '打开设置',
            aspectRatio: '长宽比',
            outputCount: '输出数量',
            resolution: '分辨率',
            duration: '时长',
            secondsLabel: '{value}秒',
        },
        avatar: '形象',
        firstFrame: '首帧',
        lastFrame: '尾帧',
        keyframesUpload: {
            firstFrameAlt: '首帧',
            lastFrameAlt: '尾帧',
            removeFirstFrame: '移除首帧',
            removeLastFrame: '移除尾帧',
        },
        toolOptions: {
            mode: '模式',
            backgroundColor: '背景颜色',
            outputFormat: '输出格式',
            type: '类型',
            extendDuration: '延长时长',
            backgroundDescription: '背景描述',
            aspectRatio: '比例',
            translateTo: '翻译至',
        },
        toolOptionValues: {
            motionType: {
                move: '动作驱动',
                replace: '角色替换',
            },
            videoExtenderStyle: {
                anime: '动漫',
                '3dAnimation': '3D动画',
                cyberpunk: '赛博朋克',
                comic: '漫画',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder: '请输入提示词描述视频延长内容...',
        },
        languageNames: {
            zh: '中文',
            tw: '繁體中文',
            en: 'English',
            ja: '日本語',
            ko: '한국어',
            es: 'Español',
            fr: 'Français',
            de: 'Deutsch',
            ru: 'Русский',
            pl: 'Polski',
            pt: 'Português',
            it: 'Italiano',
            ar: 'العربية',
            th: 'ภาษาไทย',
            da: 'Dansk',
            no: 'Norsk bokmål',
            nl: 'Nederlands',
            id: 'Bahasa Indonesia',
            tr: 'Türkçe',
        },
        promptPlaceholder: '输入您的想法以生成',
        modePromptPlaceholders: {
            chat: '你想聊什么，或告诉我你想完成什么',
            image: '描述你想生成的图片，如主体、风格、场景',
            video: '描述你想生成的视频，如镜头、动作、场景',
            music: '描述音乐风格、情绪或主题',
        },
        promptPlaceholderToday: '今天你想生成什么',
        positivePrompt: '正向提示词',
        negativePrompt: '负向提示词',
        negativePromptPlaceholder: '请输入负向提示词',
        videoModeMulti: '多图生成',
        videoModeAddLastFrame: '添加尾帧',
        credits: '{count}',
        uploadingWait: '正在上传中，请等待上传完成后再粘贴上传。',
        noEmptySlot: '没有可用的空槽位可粘贴图片。',
        maxPasteLimit: '最多可以上传 {count} 个文件',
        formatSupport: '当前创作模式不支持该文件类型：',
        andOthers: ' 等{count}个文件',
        notSupportPaste: '当前工具不支持粘贴图片。',
        onlyOneVideo: '仅支持上传 1 个视频文件。',
        videoTooLargePrompt: '视频文件过大，请上传 {size} 以内的视频。',
        templateSlotLimit: '每个模板槽位仅支持上传 1 张图片。',
        uploadingWaitDrag: '正在上传中，请等待上传完成后再拖拽上传。',
        uploadTypeCheck: '当前创作模式不支持该文件类型。',
        imageSizeLimitPrompt: '图片大小不能超过 100MB。',
        imageResolutionLimitPrompt: '图片分辨率过大，最长边不能超过 4096px。',
        noImageField: '当前工具没有图片上传字段，无法粘贴图片。',
        maxUploadLimit: '最多只能上传 {count} 张图片。',
        audioUploaded: '音频已上传',
        uploaded: '已上传',
        audioReadTimeout: '读取音频信息超时',
        invalidAudioDuration: '无法获取有效的音频时长',
        audioReadFailed: '无法读取音频信息',
        pleaseUploadAudio: '请上传音频文件',
        audioTooLong: '音频时长不能超过 5 分钟',
        audioUploadSuccess: '音频上传成功',
        audioUploadFailed: '音频上传失败',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: '图片',
            videoGenerate: '视频',
            musicGenerate: '音乐',
            imageEdit: '图片编辑',
            videoEdit: '视频编辑',
            imageTemplate: '图片模版',
            videoTemplate: '视频模版',
            tools: '工具',
        },
        secondaryTabs: {
            textToImage: '文生图',
            imageToImage: '图生图',
            characterToImage: '角色生图',
            textToVideo: '文生视频',
            imageToVideo: '图生视频',
            keyframes: '首尾帧',
            characterToVideo: '角色生视频',
            videoEdit: '视频编辑',
            voice: '人声',
            pureMusic: '纯音乐',
        },
        seedanceVideoModes: {
            allRound: '全能参考',
        },
        tertiaryTabs: {
            boyVoice: '男声',
            girlVoice: '女声',
        },
        configGroups: {
            voiceGender: '声线',
            tags: '标签',
        },
        audioGenerated: '已生成音频',
        successAudioLinkAdded: '音频链接添加成功',
        audio: '音频',
        audioLink: '音频链接',
        uploadAudio: '上传音频',
        addAudio: '添加音频',
        musicPrompt: {
            removeTag: '移除标签',
            creativeThemeTitle: '创意主题',
            creativeThemePlaceholder: '描述音乐风格、情绪或主题',
            lyricsTitle: '输入歌词',
            lyricsPlaceholder: '输入歌词...',
        },
        uploadLabels: {
            video: '视频',
            image: '图片',
            audio: '音频',
            baseImage: '底图',
            face: '人脸',
        },
        videoReadTimeout: '读取视频信息超时',
        invalidVideoDuration: '无法获取有效的视频时长',
        videoReadFailed: '无法读取视频信息',
        seedanceAlmighty: {
            panelTitle: '参考内容',
            emptyTitle: '上传参考',
            dragMaterialsHere: '将素材拖拽到此处',
            promptPlaceholder: "上传1-12个参考素材。输入文字并{'@'}素材即可自由组合，例：{'@'}图片1模仿{'@'}视频1 用{'@'}音频1。",
            promptPlaceholderDance25: "上传参考素材。输入文字并{'@'}素材即可自由组合，例：{'@'}图片1模仿{'@'}视频1并使用{'@'}音频1。",
            promptMaxLength: '提示词最多输入 {count} 个字符。',
            imageMaxCount: '参考图片最多上传 {count} 张。',
            videoDurationRange: '当前视频时长为 {current}，请上传 {min}-{max} 秒的视频。',
            videoMaxCount: '参考视频最多上传 {count} 个。',
            videoTotalDuration: '当前上传后视频总时长为 {current}，不能超过 {max} 秒。',
            audioDurationRange: '当前音频时长为 {current}，请上传 {min}-{max} 秒的音频。',
            audioMaxCount: '参考音频最多上传 {count} 段。',
            audioTotalDuration: '当前上传后音频总时长为 {current}，不能超过 {max} 秒。',
            mediaTotalDuration: '当前上传后参考视频和音频总时长为 {current}，不能超过 {max} 秒。',
            audioNeedsVisualReference: '音频不能单独上传，请至少保留 1 个参考图片或参考视频。',
            referenceRequired: '请至少上传 1 个参考图片或参考视频。',
            uploadHints: {
                image: '支持上传图片1-9张、视频最多3个、音频最多3个（单个2-15秒，视频和音频总时长分别不超过15秒）',
                dance25: '支持最多 {imageCount} 张图片、{videoCount} 个视频和 {audioCount} 段音频（视频/音频单个 {minDuration}-{maxDuration} 秒，视频与音频总时长分别不超过 {totalDuration} 秒）',
            },
        },
        uploadStrip: {
            removeVideo: '移除视频',
            removeImage: '移除图片',
            removeAudio: '移除音频',
        },
        toolTitles: {
            'video-motion-imitation': 'AI视频动作模仿',
            'video-face-swap': 'AI视频换脸',
            'video-to-anime': 'AI视频动漫转换器',
            'video-subtitle-translate': 'AI字幕翻译',
            'video-upscaler': 'AI视频增强',
            'video-background-remover': 'AI视频背景去除',
            'video-watermark-remover': 'AI去水印',
            'remove-video-subtitles': 'AI字幕擦除',
            'video-extender': 'AI视频延长器',
            'image-background-changer': 'AI图片背景更换器',
            'image-resizer': 'AI图像尺寸调整器',
            'image-text-translate': 'AI图片翻译文字',
            'image-upscaler': 'AI画质增强',
            'photo-face-swap': '人脸替换',
            'remove-text-image': 'AI图片文本删除',
            'ai-image-extender': 'AI图片扩展',
            'photo-restoration': '老照片修复',
            'ai-image-background-remover': 'AI图片背景移除',
            'video-lip-sync': 'AI视频对口型',
        },
        // 我的项目
        myProject: '我的项目',
        noProject: '暂无项目',
        newProject: '新建项目',
        // 历史记录 hover 操作
        addToInput: '加入创作',
        reAdd: '重新添加',
        imageEdit: '图片编辑',
        videoEdit: '视频编辑',
        videoToolCannotUploadImage: '视频编辑工具只可上传视频不可以上传图片',
        videoEditOnlySupportVideo: '视频编辑只支持上传视频',
        videoAddedToTool: '视频已添加到工具',
        switchedToImageMode: '已切换到图生图模式',
        switchedToVideoMode: '已切换到视频编辑模式',
        reEdit: '重新编辑',
        musicCannotReEdit: '音乐创作不支持重新编辑',
    },
    en: {
        importLink: 'Import Link',
        videoPreview: 'Video Preview',
        modeSelect: 'Mode Selection',
        reselect: 'Reselect',
        select: 'Select',
        selectModel: 'Select Model',
        openQuickSwitches: 'Open quick switches',
        quickSettings: {
            openSettings: 'Open settings',
            aspectRatio: 'Aspect ratio',
            outputCount: 'Output count',
            resolution: 'Resolution',
            duration: 'Duration',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Start',
        lastFrame: 'End',
        keyframesUpload: {
            firstFrameAlt: 'First frame',
            lastFrameAlt: 'Last frame',
            removeFirstFrame: 'Remove first frame',
            removeLastFrame: 'Remove last frame',
        },
        toolOptions: {
            mode: 'Mode',
            backgroundColor: 'Background color',
            outputFormat: 'Output format',
            type: 'Type',
            extendDuration: 'Extend duration',
            backgroundDescription: 'Background description',
            aspectRatio: 'Aspect ratio',
            translateTo: 'Translate to',
        },
        toolOptionValues: {
            motionType: {
                move: 'Motion driven',
                replace: 'Character swap',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D animation',
                cyberpunk: 'Cyberpunk',
                comic: 'Comic',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Describe what you want to extend in the video...',
        },
        languageNames: {
            zh: 'Chinese (Simplified)',
            tw: 'Chinese (Traditional)',
            en: 'English',
            ja: 'Japanese',
            ko: 'Korean',
            es: 'Spanish',
            fr: 'French',
            de: 'German',
            ru: 'Russian',
            pl: 'Polish',
            pt: 'Portuguese',
            it: 'Italian',
            ar: 'Arabic',
            th: 'Thai',
            da: 'Danish',
            no: 'Norwegian (Bokmål)',
            nl: 'Dutch',
            id: 'Indonesian',
            tr: 'Turkish',
        },
        promptPlaceholder: 'Describe what you want to generate',
        modePromptPlaceholders: {
            chat: 'What would you like to chat about or get done?',
            image: 'Describe the image you want to generate, such as subject, style, and scene',
            video: 'Describe the video you want to generate, such as shots, motion, and scene',
            music: 'Describe the music style, mood, or theme',
        },
        promptPlaceholderToday: 'What would you like to generate today?',
        positivePrompt: 'Positive Prompt',
        negativePrompt: 'Negative Prompt',
        negativePromptPlaceholder: 'Enter negative prompt',
        videoModeMulti: 'Multi-image Generation',
        videoModeAddLastFrame: 'Add Last Frame',
        credits: '{count}',
        uploadingWait: 'Uploading, please wait until finished before pasting.',
        noEmptySlot: 'No empty slots available to paste images.',
        maxPasteLimit: 'You can upload up to {count} files.',
        formatSupport: 'The current creation mode does not support this file type: ',
        andOthers: ' and {count} other files',
        notSupportPaste: 'Current tool does not support pasting images.',
        onlyOneVideo: 'Only 1 video file can be uploaded.',
        videoTooLargePrompt: 'Video file is too large, please upload a video within {size}.',
        templateSlotLimit: 'Each template slot only supports 1 image.',
        uploadingWaitDrag: 'Uploading, please wait until finished before dragging.',
        uploadTypeCheck: 'The current creation mode does not support this file type.',
        imageSizeLimitPrompt: 'Image size cannot exceed 100MB.',
        imageResolutionLimitPrompt: 'Image resolution is too large, the longest side cannot exceed 4096px.',
        noImageField: 'Current tool has no image upload field, cannot paste images.',
        maxUploadLimit: 'Can only upload up to {count} images.',
        audioUploaded: 'Audio uploaded',
        uploaded: 'Uploaded',
        audioReadTimeout: 'Audio info read timeout',
        invalidAudioDuration: 'Cannot get valid audio duration',
        audioReadFailed: 'Cannot read audio info',
        pleaseUploadAudio: 'Please upload audio file',
        audioTooLong: 'Audio duration cannot exceed 5 minutes',
        audioUploadSuccess: 'Audio uploaded successfully',
        audioUploadFailed: 'Audio upload failed',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Image',
            videoGenerate: 'Video',
            musicGenerate: 'Music',
            imageEdit: 'Image Edit',
            videoEdit: 'Video Edit',
            imageTemplate: 'Image Templates',
            videoTemplate: 'Video Templates',
            tools: 'Toolkits',
        },
        secondaryTabs: {
            textToImage: 'Text to Image',
            imageToImage: 'Image to Image',
            characterToImage: 'Character to Image',
            textToVideo: 'Text to Video',
            imageToVideo: 'Image to Video',
            keyframes: 'First/Last Frame',
            characterToVideo: 'Character to Video',
            videoEdit: 'Video Edit',
            voice: 'Vocal',
            pureMusic: 'Instrumental',
        },
        seedanceVideoModes: {
            allRound: 'All-round Reference',
        },
        tertiaryTabs: {
            boyVoice: 'Male Voice',
            girlVoice: 'Female Voice',
        },
        configGroups: {
            voiceGender: 'Voice Type',
            tags: 'Tags',
        },
        audioGenerated: 'Audio Generated',
        successAudioLinkAdded: 'Audio link added successfully',
        audio: 'Audio',
        audioLink: 'Audio Link',
        uploadAudio: 'Upload Audio',
        addAudio: 'Add Audio',
        musicPrompt: {
            removeTag: 'Remove tag',
            creativeThemeTitle: 'Creative Theme',
            creativeThemePlaceholder: 'Describe the music style, mood, or theme',
            lyricsTitle: 'Enter Lyrics',
            lyricsPlaceholder: 'Enter lyrics...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Image',
            audio: 'Audio',
            baseImage: 'Base image',
            face: 'Face',
        },
        videoReadTimeout: 'Video info read timeout',
        invalidVideoDuration: 'Cannot get valid video duration',
        videoReadFailed: 'Cannot read video info',
        seedanceAlmighty: {
            panelTitle: 'Reference Content',
            emptyTitle: 'Upload References',
            dragMaterialsHere: 'Drag materials here',
            promptPlaceholder: "Upload 1-12 reference assets. Enter text and tag {'@'}assets to combine them freely. Example: let {'@'}Image1 imitate {'@'}Video1 using {'@'}Audio1.",
            promptPlaceholderDance25: "Upload reference assets. Enter text and tag {'@'}assets to combine them freely. Example: let {'@'}Image1 imitate {'@'}Video1 using {'@'}Audio1.",
            promptMaxLength: 'Prompt must be no longer than {count} characters.',
            imageMaxCount: 'You can upload up to {count} reference images.',
            videoDurationRange: 'This video is {current}. Please upload a video between {min} and {max} seconds.',
            videoMaxCount: 'You can upload up to {count} reference videos.',
            videoTotalDuration: 'The total video duration after upload would be {current}, which exceeds the {max}-second limit.',
            audioDurationRange: 'This audio clip is {current}. Please upload audio between {min} and {max} seconds.',
            audioMaxCount: 'You can upload up to {count} reference audio clips.',
            audioTotalDuration: 'The total audio duration after upload would be {current}, which exceeds the {max}-second limit.',
            mediaTotalDuration: 'The total duration of reference videos and audio after upload would be {current}, which exceeds the {max}-second limit.',
            audioNeedsVisualReference: 'Audio cannot be used alone. Keep at least one reference image or video.',
            referenceRequired: 'Upload at least one reference image or reference video.',
            uploadHints: {
                image: 'Supports 1-9 images, up to 3 videos, and up to 3 audio files (each 2-15s; video and audio totals are calculated separately, each <= 15s)',
                dance25: 'Supports up to {imageCount} images, {videoCount} videos, and {audioCount} audio files (each video/audio {minDuration}-{maxDuration}s; video and audio totals are calculated separately, each <= {totalDuration}s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Remove video',
            removeImage: 'Remove image',
            removeAudio: 'Remove audio',
        },
        toolTitles: {
            'video-motion-imitation': 'AI Video Motion Imitation',
            'video-face-swap': 'AI Video Face Swap',
            'video-to-anime': 'AI Video Anime Converter',
            'video-subtitle-translate': 'AI Subtitle Translation',
            'video-upscaler': 'AI Video Enhancement',
            'video-background-remover': 'AI Video Background Removal',
            'video-watermark-remover': 'AI Watermark Remover',
            'remove-video-subtitles': 'AI Subtitle Eraser',
            'video-extender': 'AI Video Extender',
            'image-background-changer': 'AI Image Background Changer',
            'image-resizer': 'AI Image Resizer',
            'image-text-translate': 'AI Image Text Translation',
            'image-upscaler': 'AI Image Quality Enhancement',
            'photo-face-swap': 'Face Replacement',
            'remove-text-image': 'AI Image Text Remover',
            'ai-image-extender': 'AI Image Extender',
            'photo-restoration': 'Old Photo Restoration',
            'ai-image-background-remover': 'AI Image Background Remover',
            'video-lip-sync': 'AI Video Lip Sync',
        },
        // My Projects
        myProject: 'My Projects',
        noProject: 'No Projects Yet',
        newProject: 'New Project',
        // History hover actions
        addToInput: 'Add to Creation',
        reAdd: 'Re-add',
        imageEdit: 'Image Edit',
        videoEdit: 'Video Edit',
        videoToolCannotUploadImage: 'Video editing tools can only upload videos, not images',
        videoEditOnlySupportVideo: 'Video editing only supports uploading videos',
        videoAddedToTool: 'Video added to tool',
        switchedToImageMode: 'Switched to image-to-image mode',
        switchedToVideoMode: 'Switched to video editing mode',
        reEdit: 'Re-edit',
        musicCannotReEdit: 'Music creation cannot be re-edited',
    },
    ja: {
        importLink: 'リンクをインポート',
        videoPreview: '動画プレビュー',
        modeSelect: 'モード選択',
        reselect: '再選択',
        select: '選択',
        selectModel: 'モデルを選択',
        openQuickSwitches: 'クイックスイッチを開く',
        quickSettings: {
            openSettings: '設定を開く',
            aspectRatio: 'アスペクト比',
            outputCount: '出力数',
            resolution: '解像度',
            duration: '長さ',
            secondsLabel: '{value}秒',
        },
        avatar: 'アバター',
        firstFrame: '開始',
        lastFrame: '終了',
        keyframesUpload: {
            firstFrameAlt: '最初のフレーム',
            lastFrameAlt: '最後のフレーム',
            removeFirstFrame: '最初のフレームを削除',
            removeLastFrame: '最後のフレームを削除',
        },
        toolOptions: {
            mode: 'モード',
            backgroundColor: '背景色',
            outputFormat: '出力形式',
            type: '種類',
            extendDuration: '延長時間',
            backgroundDescription: '背景の説明',
            aspectRatio: 'アスペクト比',
            translateTo: '翻訳先',
        },
        toolOptionValues: {
            motionType: {
                move: '動作駆動',
                replace: 'キャラクター置換',
            },
            videoExtenderStyle: {
                anime: 'アニメ',
                '3dAnimation': '3Dアニメーション',
                cyberpunk: 'サイバーパンク',
                comic: 'コミック',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'プロンプトで動画の延長内容を説明してください...',
        },
        languageNames: {
            zh: '中国語（簡体）',
            tw: '中国語（繁体）',
            en: '英語',
            ja: '日本語',
            ko: '韓国語',
            es: 'スペイン語',
            fr: 'フランス語',
            de: 'ドイツ語',
            ru: 'ロシア語',
            pl: 'ポーランド語',
            pt: 'ポルトガル語',
            it: 'イタリア語',
            ar: 'アラビア語',
            th: 'タイ語',
            da: 'デンマーク語',
            no: 'ノルウェー語（ブークモール）',
            nl: 'オランダ語',
            id: 'インドネシア語',
            tr: 'トルコ語',
        },
        promptPlaceholder: '生成したい内容を入力してください',
        modePromptPlaceholders: {
            chat: '何について話したいですか？または何をしたいか教えてください',
            image: '生成したい画像について、被写体、スタイル、シーンなどを説明してください',
            video: '生成したい動画について、ショット、動き、シーンなどを説明してください',
            music: '音楽のスタイル、ムード、またはテーマを説明してください',
        },
        promptPlaceholderToday: '今日は何を生成したいですか？',
        positivePrompt: 'ポジティブプロンプト',
        negativePrompt: 'ネガティブプロンプト',
        negativePromptPlaceholder: 'ネガティブプロンプトを入力',
        videoModeMulti: '複数画像生成',
        videoModeAddLastFrame: '最後のフレームを追加',
        credits: '{count}',
        maxPasteLimit: '最大で {count} 個のファイルをアップロードできます。',
        primaryTabs: {
            chat: 'チャット',
            imageGenerate: '画像',
            videoGenerate: '動画',
            musicGenerate: '音楽',
            imageEdit: '画像編集',
            videoEdit: '動画編集',
            imageTemplate: '画像テンプレート',
            videoTemplate: '動画テンプレート',
            tools: 'ツール',
        },
        secondaryTabs: {
            textToImage: 'テキストから画像',
            imageToImage: '画像から画像',
            characterToImage: 'キャラクターから画像',
            textToVideo: 'テキストから動画',
            imageToVideo: '画像から動画',
            keyframes: '最初/最後フレーム',
            characterToVideo: 'キャラクターから動画',
            videoEdit: '動画編集',
            voice: 'ボーカル',
            pureMusic: 'インストゥルメンタル',
        },
        seedanceVideoModes: {
            allRound: 'オールラウンド参照',
        },
        tertiaryTabs: {
            boyVoice: '男性の声',
            girlVoice: '女性の声',
        },
        configGroups: {
            voiceGender: '声の種類',
            tags: 'タグ',
        },
        audioGenerated: '音声生成済み',
        successAudioLinkAdded: '音声リンクが追加されました',
        audio: 'オーディオ',
        audioLink: 'オーディオリンク',
        uploadAudio: 'オーディオをアップロード',
        addAudio: 'オーディオを追加',
        uploadTypeCheck: '現在の作成モードではこのファイル形式はサポートされていません。',
        imageSizeLimitPrompt: '画像サイズは100MB以下にしてください。',
        imageResolutionLimitPrompt: '画像の解像度が大きすぎます。長辺は4096px以下にしてください。',
        musicPrompt: {
            removeTag: 'タグを削除',
            creativeThemeTitle: 'クリエイティブテーマ',
            creativeThemePlaceholder: '音楽のスタイル、ムード、またはテーマを説明してください',
            lyricsTitle: '歌詞を入力',
            lyricsPlaceholder: '歌詞を入力...',
        },
        uploadLabels: {
            video: '動画',
            image: '画像',
            audio: 'オーディオ',
            baseImage: '元画像',
            face: '顔',
        },
        seedanceAlmighty: {
            panelTitle: '参照内容',
            emptyTitle: '参照をアップロード',
            dragMaterialsHere: '素材をここにドラッグしてください',
            promptPlaceholder: "1〜12件の参照素材をアップロードしてください。テキストを入力し、{'@'}素材を付けて自由に組み合わせられます。例: {'@'}画像1 に {'@'}動画1 を真似させ、{'@'}オーディオ1 を使います。",
            promptPlaceholderDance25: "参照素材をアップロードしてください。テキストを入力し、{'@'}素材を付けて自由に組み合わせられます。例: {'@'}画像1 に {'@'}動画1 を真似させ、{'@'}オーディオ1 を使います。",
            promptMaxLength: 'プロンプトは {count} 文字以内で入力してください。',
            imageMaxCount: '参照画像は最大 {count} 枚までアップロードできます。',
            videoDurationRange: '現在の動画の長さは {current} です。{min}〜{max} 秒の動画をアップロードしてください。',
            videoMaxCount: '参照動画は最大 {count} 本までアップロードできます。',
            videoTotalDuration: 'アップロード後の動画の合計時間は {current} となり、{max} 秒を超えています。',
            audioDurationRange: '現在の音声の長さは {current} です。{min}〜{max} 秒の音声をアップロードしてください。',
            audioMaxCount: '参照音声は最大 {count} 件までアップロードできます。',
            audioTotalDuration: 'アップロード後の音声の合計時間は {current} となり、{max} 秒を超えています。',
            mediaTotalDuration: 'アップロード後の参照動画と音声の合計時間は {current} となり、{max} 秒を超えています。',
            audioNeedsVisualReference: '音声のみではアップロードできません。参照画像または参照動画を少なくとも 1 つ残してください。',
            referenceRequired: '参照画像または参照動画を少なくとも 1 つアップロードしてください。',
            uploadHints: {
                image: '画像は1〜9枚、動画は最大3件、音声は最大3件までアップロード可能です（各2〜15秒、動画と音声の合計時間は別々に各15秒以内）',
                dance25: '画像は最大{imageCount}枚、動画は最大{videoCount}件、音声は最大{audioCount}件まで対応します（動画・音声は各{minDuration}〜{maxDuration}秒、動画と音声の合計時間は別々に各{totalDuration}秒以内）',
            },
        },
        uploadStrip: {
            removeVideo: '動画を削除',
            removeImage: '画像を削除',
            removeAudio: 'オーディオを削除',
        },
        toolTitles: {
            'video-motion-imitation': 'AI動画モーション模倣',
            'video-face-swap': 'AI動画顔交換',
            'video-to-anime': 'AI動画アニメ変換器',
            'video-subtitle-translate': 'AI字幕翻訳',
            'video-upscaler': 'AI動画強化',
            'video-background-remover': 'AI動画背景除去',
            'video-watermark-remover': 'AI透かし除去',
            'remove-video-subtitles': 'AI字幕消去',
            'video-extender': 'AI動画延長ツール',
            'image-background-changer': 'AI画像背景チェンジャー',
            'image-resizer': 'AI画像リサイズ',
            'image-text-translate': 'AI画像文字翻訳',
            'image-upscaler': 'AI画質強化',
            'photo-face-swap': '顔置換',
            'remove-text-image': 'AI画像テキスト削除',
            'ai-image-extender': 'AI画像拡張',
            'photo-restoration': '古い写真修復',
            'ai-image-background-remover': 'AI画像背景除去',
            'video-lip-sync': 'AI動画リップシンク',
        },
        // マイプロジェクト
        myProject: 'マイプロジェクト',
        noProject: 'プロジェクトがありません',
        newProject: '新規プロジェクト',
        // 履歴ホバーアクション
        addToInput: '作成に参加',
        reAdd: '再追加',
        imageEdit: '画像編集',
        videoEdit: '動画編集',
        videoToolCannotUploadImage: '動画編集ツールは動画のみアップロード可能で、画像はアップロードできません',
        videoEditOnlySupportVideo: '動画編集は動画のアップロードのみ対応しています',
        videoAddedToTool: '動画がツールに追加されました',
        switchedToImageMode: '画像から画像モードに切り替わりました',
        switchedToVideoMode: '動画編集モードに切り替わりました',
        reEdit: '再編集',
        musicCannotReEdit: '音楽作成は再編集できません',
    },
    ko: {
        importLink: '링크 가져오기',
        videoPreview: '비디오 미리보기',
        modeSelect: '모드 선택',
        reselect: '다시 선택',
        select: '선택',
        selectModel: '모델 선택',
        openQuickSwitches: '빠른 스위치 열기',
        quickSettings: {
            openSettings: '설정 열기',
            aspectRatio: '종횡비',
            outputCount: '출력 개수',
            resolution: '해상도',
            duration: '길이',
            secondsLabel: '{value}초',
        },
        avatar: '아바타',
        firstFrame: '시작',
        lastFrame: '끝',
        keyframesUpload: {
            firstFrameAlt: '첫 프레임',
            lastFrameAlt: '마지막 프레임',
            removeFirstFrame: '첫 프레임 제거',
            removeLastFrame: '마지막 프레임 제거',
        },
        toolOptions: {
            mode: '모드',
            backgroundColor: '배경 색상',
            outputFormat: '출력 형식',
            type: '유형',
            extendDuration: '연장 시간',
            backgroundDescription: '배경 설명',
            aspectRatio: '종횡비',
            translateTo: '번역 대상',
        },
        toolOptionValues: {
            motionType: {
                move: '동작 구동',
                replace: '캐릭터 교체',
            },
            videoExtenderStyle: {
                anime: '애니메이션',
                '3dAnimation': '3D 애니메이션',
                cyberpunk: '사이버펑크',
                comic: '만화',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                '프롬프트로 비디오 연장 내용을 설명하세요...',
        },
        languageNames: {
            zh: '중국어(간체)',
            tw: '중국어(번체)',
            en: '영어',
            ja: '일본어',
            ko: '한국어',
            es: '스페인어',
            fr: '프랑스어',
            de: '독일어',
            ru: '러시아어',
            pl: '폴란드어',
            pt: '포르투갈어',
            it: '이탈리아어',
            ar: '아랍어',
            th: '태국어',
            da: '덴마크어',
            no: '노르웨이어(보크몰)',
            nl: '네덜란드어',
            id: '인도네시아어',
            tr: '터키어',
        },
        promptPlaceholder: '생성할 내용을 입력하세요',
        modePromptPlaceholders: {
            chat: '무엇을 이야기하고 싶은지, 또는 무엇을 하고 싶은지 알려주세요',
            image: '생성할 이미지의 주제, 스타일, 장면 등을 설명하세요',
            video: '생성할 비디오의 장면, 움직임, 구도 등을 설명하세요',
            music: '음악 스타일, 분위기 또는 테마를 설명하세요',
        },
        promptPlaceholderToday: '오늘 무엇을 생성하고 싶으신가요?',
        positivePrompt: '긍정 프롬프트',
        negativePrompt: '부정 프롬프트',
        negativePromptPlaceholder: '부정 프롬프트를 입력하세요',
        videoModeMulti: '다중 이미지 생성',
        videoModeAddLastFrame: '마지막 프레임 추가',
        credits: '{count}',
        uploadingWait: '업로드 중입니다. 완료될 때까지 기다렸다가 붙여넣으세요.',
        noEmptySlot: '이미지를 붙여넣을 수 있는 빈 슬롯이 없습니다.',
        maxPasteLimit: '최대 {count}개의 파일을 업로드할 수 있습니다.',
        formatSupport: '현재 생성 모드에서는 이 파일 형식을 지원하지 않습니다: ',
        andOthers: ' 외 {count}개 파일',
        notSupportPaste: '현재 도구는 이미지 붙여넣기를 지원하지 않습니다.',
        onlyOneVideo: '비디오 파일은 1개만 업로드할 수 있습니다.',
        videoTooLargePrompt: '비디오 파일이 너무 큽니다. {size} 이내의 비디오를 업로드하세요.',
        templateSlotLimit: '각 템플릿 슬롯은 1장의 이미지만 지원합니다.',
        uploadingWaitDrag: '업로드 중입니다. 완료될 때까지 기다렸다가 드래그하세요.',
        uploadTypeCheck: '현재 생성 모드에서는 이 파일 형식을 지원하지 않습니다.',
        imageSizeLimitPrompt: '이미지 크기는 100MB를 초과할 수 없습니다.',
        imageResolutionLimitPrompt: '이미지 해상도가 너무 큽니다. 가장 긴 면은 4096px를 초과할 수 없습니다.',
        primaryTabs: {
            chat: '채팅',
            imageGenerate: '이미지',
            videoGenerate: '비디오',
            musicGenerate: '음악',
            imageEdit: '이미지 편집',
            videoEdit: '비디오 편집',
            imageTemplate: '이미지 템플릿',
            videoTemplate: '비디오 템플릿',
            tools: '도구',
        },
        secondaryTabs: {
            textToImage: '텍스트-이미지',
            imageToImage: '이미지-이미지',
            characterToImage: '캐릭터-이미지',
            textToVideo: '텍스트-비디오',
            imageToVideo: '이미지-비디오',
            keyframes: '첫/마지막 프레임',
            characterToVideo: '캐릭터-비디오',
            videoEdit: '비디오 편집',
            voice: '보컬',
            pureMusic: '인스트루멘탈',
        },
        seedanceVideoModes: {
            allRound: '만능 참고',
        },
        tertiaryTabs: {
            boyVoice: '남성 음성',
            girlVoice: '여성 음성',
        },
        configGroups: {
            voiceGender: '음성 유형',
            tags: '태그',
        },
        audioGenerated: '오디오 생성됨',
        successAudioLinkAdded: '오디오 링크가 추가되었습니다',
        audio: '오디오',
        audioLink: '오디오 링크',
        uploadAudio: '오디오 업로드',
        addAudio: '오디오 추가',
        musicPrompt: {
            removeTag: '태그 제거',
            creativeThemeTitle: '창의적 주제',
            creativeThemePlaceholder: '음악 스타일, 분위기 또는 테마를 설명하세요',
            lyricsTitle: '가사 입력',
            lyricsPlaceholder: '가사를 입력하세요...',
        },
        uploadLabels: {
            video: '비디오',
            image: '이미지',
            audio: '오디오',
            baseImage: '기본 이미지',
            face: '얼굴',
        },
        seedanceAlmighty: {
            panelTitle: '참고 콘텐츠',
            emptyTitle: '참고 업로드',
            dragMaterialsHere: '소재를 여기에 드래그하세요',
            promptPlaceholder: "참고 소재 1-12개를 업로드하세요. 텍스트를 입력하고 {'@'}소재를 붙여 자유롭게 조합할 수 있습니다. 예: {'@'}이미지1 이 {'@'}비디오1 을 따라 하고 {'@'}오디오1 을 사용합니다.",
            promptPlaceholderDance25: "참고 소재를 업로드하세요. 텍스트를 입력하고 {'@'}소재를 붙여 자유롭게 조합할 수 있습니다. 예: {'@'}이미지1 이 {'@'}비디오1 을 따라 하고 {'@'}오디오1 을 사용합니다.",
            promptMaxLength: '프롬프트는 최대 {count}자까지 입력할 수 있습니다.',
            imageMaxCount: '참조 이미지는 최대 {count}장까지 업로드할 수 있습니다.',
            videoDurationRange: '현재 비디오 길이는 {current}입니다. {min}~{max}초 길이의 비디오를 업로드해 주세요.',
            videoMaxCount: '참조 비디오는 최대 {count}개까지 업로드할 수 있습니다.',
            videoTotalDuration: '업로드 후 비디오 총 길이는 {current}로, {max}초를 초과합니다.',
            audioDurationRange: '현재 오디오 길이는 {current}입니다. {min}~{max}초 길이의 오디오를 업로드해 주세요.',
            audioMaxCount: '참조 오디오는 최대 {count}개까지 업로드할 수 있습니다.',
            audioTotalDuration: '업로드 후 오디오 총 길이는 {current}로, {max}초를 초과합니다.',
            mediaTotalDuration: '업로드 후 참조 비디오와 오디오의 총 길이는 {current}로, {max}초를 초과합니다.',
            audioNeedsVisualReference: '오디오만 단독으로 업로드할 수 없습니다. 참조 이미지나 참조 비디오를 최소 1개 유지하세요.',
            referenceRequired: '참조 이미지 또는 참조 비디오를 최소 1개 업로드하세요.',
            uploadHints: {
                image: '이미지 1-9장, 비디오 최대 3개, 오디오 최대 3개 업로드 가능(각 2-15초, 비디오와 오디오 총 길이는 별도로 각각 15초 이내)',
                dance25: '이미지 최대 {imageCount}장, 비디오 {videoCount}개, 오디오 {audioCount}개 지원(비디오/오디오 각 {minDuration}-{maxDuration}초, 비디오와 오디오 총 길이는 별도로 각각 {totalDuration}초 이내)',
            },
        },
        uploadStrip: {
            removeVideo: '비디오 제거',
            removeImage: '이미지 제거',
            removeAudio: '오디오 제거',
        },
        toolTitles: {
            'video-motion-imitation': 'AI 비디오 동작 모방',
            'video-face-swap': 'AI 비디오 얼굴 교체',
            'video-to-anime': 'AI 비디오 애니 변환기',
            'video-subtitle-translate': 'AI 자막 번역',
            'video-upscaler': 'AI 비디오 향상',
            'video-background-remover': 'AI 비디오 배경 제거',
            'video-watermark-remover': 'AI 워터마크 제거',
            'remove-video-subtitles': 'AI 자막 지우기',
            'video-extender': 'AI 비디오 연장기',
            'image-background-changer': 'AI 이미지 배경 변경기',
            'image-resizer': 'AI 이미지 리사이저',
            'image-text-translate': 'AI 이미지 텍스트 번역',
            'image-upscaler': 'AI 화질 향상',
            'photo-face-swap': '얼굴 교체',
            'remove-text-image': 'AI 이미지 텍스트 삭제',
            'ai-image-extender': 'AI 이미지 확장',
            'photo-restoration': '오래된 사진 복원',
            'ai-image-background-remover': 'AI 이미지 배경 제거',
            'video-lip-sync': 'AI 비디오 립싱크',
        },
        // 내 프로젝트
        myProject: '내 프로젝트',
        noProject: '프로젝트 없음',
        newProject: '새 프로젝트',
        // 기록 호버 액션
        addToInput: '창작에 추가',
        reAdd: '다시 추가',
        imageEdit: '이미지 편집',
        videoEdit: '비디오 편집',
        videoToolCannotUploadImage: '비디오 편집 도구는 비디오만 업로드할 수 있으며 이미지는 업로드할 수 없습니다',
        videoEditOnlySupportVideo: '비디오 편집은 비디오 업로드만 지원합니다',
        videoAddedToTool: '비디오가 도구에 추가되었습니다',
        switchedToImageMode: '이미지-이미지 모드로 전환되었습니다',
        switchedToVideoMode: '비디오 편집 모드로 전환되었습니다',
        reEdit: '다시 편집',
        musicCannotReEdit: '음악 창작은 다시 편집할 수 없습니다',
    },
    tw: {
        importLink: '連結匯入',
        videoPreview: '影片預覽',
        modeSelect: '模式選擇',
        reselect: '重新選擇',
        select: '選擇',
        selectModel: '選擇模型',
        openQuickSwitches: '打開快捷開關',
        quickSettings: {
            openSettings: '開啟設定',
            aspectRatio: '長寬比',
            outputCount: '輸出數量',
            resolution: '解析度',
            duration: '時長',
            secondsLabel: '{value}秒',
        },
        avatar: '形象',
        firstFrame: '首幀',
        lastFrame: '尾幀',
        keyframesUpload: {
            firstFrameAlt: '首幀',
            lastFrameAlt: '尾幀',
            removeFirstFrame: '移除首幀',
            removeLastFrame: '移除尾幀',
        },
        toolOptions: {
            mode: '模式',
            backgroundColor: '背景顏色',
            outputFormat: '輸出格式',
            type: '類型',
            extendDuration: '延長時長',
            backgroundDescription: '背景描述',
            aspectRatio: '比例',
            translateTo: '翻譯至',
        },
        toolOptionValues: {
            motionType: {
                move: '動作驅動',
                replace: '角色替換',
            },
            videoExtenderStyle: {
                anime: '動漫',
                '3dAnimation': '3D動畫',
                cyberpunk: '賽博龐克',
                comic: '漫畫',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder: '請輸入提示詞描述影片延長內容...',
        },
        languageNames: {
            zh: '中文（簡體）',
            tw: '中文（繁體）',
            en: 'English',
            ja: '日本語',
            ko: '한국어',
            es: 'Español',
            fr: 'Français',
            de: 'Deutsch',
            ru: 'Русский',
            pl: 'Polski',
            pt: 'Português',
            it: 'Italiano',
            ar: 'العربية',
            th: 'ภาษาไทย',
            da: 'Dansk',
            no: 'Norsk bokmål',
            nl: 'Nederlands',
            id: 'Bahasa Indonesia',
            tr: 'Türkçe',
        },
        promptPlaceholder: '輸入您的想法以生成',
        modePromptPlaceholders: {
            chat: '你想聊什麼，或告訴我你想完成什麼',
            image: '描述你想生成的圖片，如主體、風格、場景',
            video: '描述你想生成的影片，如鏡頭、動作、場景',
            music: '描述音樂風格、情緒或主題',
        },
        promptPlaceholderToday: '今天你想生成什麼',
        positivePrompt: '正向提示詞',
        negativePrompt: '負向提示詞',
        negativePromptPlaceholder: '請輸入負向提示詞',
        videoModeMulti: '多圖生成',
        videoModeAddLastFrame: '添加尾幀',
        credits: '{count}',
        uploadingWait: '正在上傳中，請等待上傳完成後再粘貼上傳。',
        noEmptySlot: '沒有可用的空槽位可粘貼圖片。',
        maxPasteLimit: '最多可以上傳 {count} 個檔案',
        formatSupport: '目前黃作模式不支援此檔案類型：',
        andOthers: ' 等{count}個文件',
        notSupportPaste: '當前工具不支持粘貼圖片。',
        onlyOneVideo: '僅支持上傳 1 個視頻文件。',
        videoTooLargePrompt: '視頻文件過大，請上傳 {size} 以內的視頻。',
        templateSlotLimit: '每個模板槽位僅支持上傳 1 張圖片。',
        uploadingWaitDrag: '正在上傳中，請等待上傳完成後再拖拽上傳。',
        uploadTypeCheck: '目前黃作模式不支援此檔案類型。',
        imageSizeLimitPrompt: '圖片大小不能超過 100MB。',
        imageResolutionLimitPrompt: '圖片解析度過大，最長邊不能超過 4096px。',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: '圖片',
            videoGenerate: '影片',
            musicGenerate: '音樂',
            imageEdit: '圖片編輯',
            videoEdit: '影片編輯',
            imageTemplate: '圖片模版',
            videoTemplate: '影片模版',
            tools: '工具',
        },
        secondaryTabs: {
            textToImage: '文生圖',
            imageToImage: '圖生圖',
            characterToImage: '角色生圖',
            textToVideo: '文生影片',
            imageToVideo: '圖生影片',
            keyframes: '首尾幀',
            characterToVideo: '角色生影片',
            videoEdit: '影片編輯',
            voice: '人聲',
            pureMusic: '純音樂',
        },
        seedanceVideoModes: {
            allRound: '全能參考',
        },
        tertiaryTabs: {
            boyVoice: '男聲',
            girlVoice: '女聲',
        },
        configGroups: {
            voiceGender: '聲線',
            tags: '標籤',
        },
        audioGenerated: '已生成音頻',
        successAudioLinkAdded: '音頻連結新增成功',
        audio: '音頻',
        audioLink: '音頻連結',
        uploadAudio: '上傳音頻',
        addAudio: '添加音頻',
        musicPrompt: {
            removeTag: '移除標籤',
            creativeThemeTitle: '創意主題',
            creativeThemePlaceholder: '描述音樂風格、情緒或主題',
            lyricsTitle: '輸入歌詞',
            lyricsPlaceholder: '輸入歌詞...',
        },
        uploadLabels: {
            video: '影片',
            image: '圖片',
            audio: '音訊',
            baseImage: '底圖',
            face: '人臉',
        },
        seedanceAlmighty: {
            panelTitle: '參考內容',
            emptyTitle: '上傳參考',
            dragMaterialsHere: '將素材拖曳到此處',
            promptPlaceholder: "上傳1-12個參考素材。輸入文字並{'@'}素材即可自由組合，例：{'@'}圖片1模仿{'@'}影片1 用{'@'}音訊1。",
            promptPlaceholderDance25: "上傳參考素材。輸入文字並{'@'}素材即可自由組合，例：{'@'}圖片1模仿{'@'}影片1並使用{'@'}音訊1。",
            promptMaxLength: '提示詞最多輸入 {count} 個字元。',
            imageMaxCount: '參考圖片最多上傳 {count} 張。',
            videoDurationRange: '目前影片時長為 {current}，請上傳 {min}-{max} 秒的影片。',
            videoMaxCount: '參考影片最多上傳 {count} 個。',
            videoTotalDuration: '目前上傳後影片總時長為 {current}，不能超過 {max} 秒。',
            audioDurationRange: '目前音訊時長為 {current}，請上傳 {min}-{max} 秒的音訊。',
            audioMaxCount: '參考音訊最多上傳 {count} 段。',
            audioTotalDuration: '目前上傳後音訊總時長為 {current}，不能超過 {max} 秒。',
            mediaTotalDuration: '目前上傳後參考影片和音訊總時長為 {current}，不能超過 {max} 秒。',
            audioNeedsVisualReference: '音訊不能單獨上傳，請至少保留 1 個參考圖片或參考影片。',
            referenceRequired: '請至少上傳 1 個參考圖片或參考影片。',
            uploadHints: {
                image: '支援上傳 1-9 張圖片、最多 3 個影片、最多 3 個音訊（單個 2-15 秒，影片與音訊總時長分別不超過 15 秒）',
                dance25: '支援最多 {imageCount} 張圖片、{videoCount} 個影片和 {audioCount} 段音訊（影片/音訊單個 {minDuration}-{maxDuration} 秒，影片與音訊總時長分別不超過 {totalDuration} 秒）',
            },
        },
        uploadStrip: {
            removeVideo: '移除影片',
            removeImage: '移除圖片',
            removeAudio: '移除音訊',
        },
        toolTitles: {
            'video-motion-imitation': 'AI影片動作模仿',
            'video-face-swap': 'AI影片換臉',
            'video-to-anime': 'AI影片動漫轉換器',
            'video-subtitle-translate': 'AI字幕翻譯',
            'video-upscaler': 'AI影片增強',
            'video-background-remover': 'AI影片背景去除',
            'video-watermark-remover': 'AI去水印',
            'remove-video-subtitles': 'AI字幕擦除',
            'video-extender': 'AI影片延長器',
            'image-background-changer': 'AI圖片背景更換器',
            'image-resizer': 'AI圖像尺寸調整器',
            'image-text-translate': 'AI圖片翻譯文字',
            'image-upscaler': 'AI畫質增強',
            'photo-face-swap': '人臉替換',
            'remove-text-image': 'AI圖片文本刪除',
            'ai-image-extender': 'AI圖片擴展',
            'photo-restoration': '老照片修復',
            'ai-image-background-remover': 'AI圖片背景移除',
            'video-lip-sync': 'AI影片對口型',
        },
        // 我的專案
        myProject: '我的專案',
        noProject: '暫無專案',
        newProject: '新建專案',
        // 歷史記錄 hover 操作
        addToInput: '加入創作',
        reAdd: '重新添加',
        imageEdit: '圖片編輯',
        videoEdit: '影片編輯',
        videoToolCannotUploadImage: '影片編輯工具只可上傳影片不可以上傳圖片',
        videoEditOnlySupportVideo: '影片編輯只支援上傳影片',
        videoAddedToTool: '影片已新增到工具',
        switchedToImageMode: '已切換到圖生圖模式',
        switchedToVideoMode: '已切換到影片編輯模式',
        reEdit: '重新編輯',
        musicCannotReEdit: '音樂創作不支援重新編輯',
    },
    es: {
        importLink: 'Importar enlace',
        videoPreview: 'Vista previa de video',
        modeSelect: 'Selección de modo',
        reselect: 'Volver a seleccionar',
        select: 'Seleccionar',
        selectModel: 'Seleccionar modelo',
        openQuickSwitches: 'Abrir interruptores rápidos',
        quickSettings: {
            openSettings: 'Abrir ajustes',
            aspectRatio: 'Relación de aspecto',
            outputCount: 'Cantidad de salida',
            resolution: 'Resolución',
            duration: 'Duración',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Inicio',
        lastFrame: 'Fin',
        keyframesUpload: {
            firstFrameAlt: 'Primer fotograma',
            lastFrameAlt: 'Último fotograma',
            removeFirstFrame: 'Eliminar primer fotograma',
            removeLastFrame: 'Eliminar último fotograma',
        },
        toolOptions: {
            mode: 'Modo',
            backgroundColor: 'Color de fondo',
            outputFormat: 'Formato de salida',
            type: 'Tipo',
            extendDuration: 'Duración de extensión',
            backgroundDescription: 'Descripción del fondo',
            aspectRatio: 'Relación de aspecto',
            translateTo: 'Traducir a',
        },
        toolOptionValues: {
            motionType: {
                move: 'Impulsado por movimiento',
                replace: 'Reemplazo de personaje',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animación 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Cómic',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Describe con un prompt el contenido que quieres extender en el vídeo...',
        },
        languageNames: {
            zh: 'Chino (simplificado)',
            tw: 'Chino (tradicional)',
            en: 'Inglés',
            ja: 'Japonés',
            ko: 'Coreano',
            es: 'Español',
            fr: 'Francés',
            de: 'Alemán',
            ru: 'Ruso',
            pl: 'Polaco',
            pt: 'Portugués',
            it: 'Italiano',
            ar: 'Árabe',
            th: 'Tailandés',
            da: 'Danés',
            no: 'Noruego (Bokmål)',
            nl: 'Neerlandés',
            id: 'Indonesio',
            tr: 'Turco',
        },
        promptPlaceholder: 'Describe lo que quieres generar',
        modePromptPlaceholders: {
            chat: '¿Sobre qué te gustaría conversar o qué te gustaría hacer?',
            image: 'Describe la imagen que quieres generar, como el sujeto, el estilo y la escena',
            video: 'Describe el video que quieres generar, como planos, movimiento y escena',
            music: 'Describe el estilo musical, el ambiente o el tema',
        },
        promptPlaceholderToday: '¿Qué te gustaría generar hoy?',
        positivePrompt: 'Prompt positivo',
        negativePrompt: 'Prompt negativo',
        negativePromptPlaceholder: 'Introduce el prompt negativo',
        videoModeMulti: 'Generación con múltiples imágenes',
        videoModeAddLastFrame: 'Añadir último fotograma',
        credits: '{count}',
        uploadingWait: 'Subiendo, por favor espera hasta que termine antes de pegar.',
        noEmptySlot: 'No hay ranuras vacías disponibles para pegar imágenes.',
        maxPasteLimit: 'Puedes subir hasta {count} archivos.',
        formatSupport: 'El modo de creación actual no admite este tipo de archivo: ',
        andOthers: ' y otros {count} archivos',
        notSupportPaste: 'La herramienta actual no admite pegar imágenes.',
        onlyOneVideo: 'Solo se puede subir 1 archivo de video.',
        videoTooLargePrompt: 'El archivo de video es demasiado grande, sube un video de menos de {size}.',
        templateSlotLimit: 'Cada ranura de plantilla solo admite 1 imagen.',
        uploadingWaitDrag: 'Subiendo, por favor espera hasta que termine antes de arrastrar.',
        uploadTypeCheck: 'El modo de creación actual no admite este tipo de archivo.',
        imageSizeLimitPrompt: 'El tamaño de la imagen no puede exceder los 100MB.',
        imageResolutionLimitPrompt: 'La resolución de la imagen es demasiado grande, el lado más largo no puede exceder los 4096px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Imagen',
            videoGenerate: 'Vídeo',
            musicGenerate: 'Música',
            imageEdit: 'Edición de imagen',
            videoEdit: 'Edición de vídeo',
            imageTemplate: 'Plantillas de imagen',
            videoTemplate: 'Plantillas de vídeo',
            tools: 'Herramientas',
        },
        secondaryTabs: {
            textToImage: 'Texto a imagen',
            imageToImage: 'Imagen a imagen',
            characterToImage: 'Personaje a imagen',
            textToVideo: 'Texto a vídeo',
            imageToVideo: 'Imagen a vídeo',
            keyframes: 'Primer/último fotograma',
            characterToVideo: 'Personaje a vídeo',
            videoEdit: 'Edición de vídeo',
            voice: 'Voz',
            pureMusic: 'Música instrumental',
        },
        seedanceVideoModes: {
            allRound: 'Referencia integral',
        },
        tertiaryTabs: {
            boyVoice: 'Voz masculina',
            girlVoice: 'Voz femenina',
        },
        configGroups: {
            voiceGender: 'Tipo de voz',
            tags: 'Etiquetas',
        },
        audioGenerated: 'Audio generado',
        successAudioLinkAdded: 'Enlace de audio añadido',
        audio: 'Audio',
        audioLink: 'Enlace de audio',
        uploadAudio: 'Subir audio',
        addAudio: 'Añadir audio',
        musicPrompt: {
            removeTag: 'Eliminar etiqueta',
            creativeThemeTitle: 'Tema creativo',
            creativeThemePlaceholder:
                'Describe el estilo, el estado de ánimo o el tema de la música',
            lyricsTitle: 'Introduce la letra',
            lyricsPlaceholder: 'Introduce la letra...',
        },
        uploadLabels: {
            video: 'Vídeo',
            image: 'Imagen',
            audio: 'Audio',
            baseImage: 'Imagen base',
            face: 'Rostro',
        },
        seedanceAlmighty: {
            panelTitle: 'Contenido de referencia',
            emptyTitle: 'Subir referencias',
            dragMaterialsHere: 'Arrastra los materiales aquí',
            promptPlaceholder: "Sube 1-12 recursos de referencia. Escribe texto y usa {'@'}recursos para combinarlos libremente. Ejemplo: {'@'}Imagen1 imita {'@'}Video1 usando {'@'}Audio1.",
            promptPlaceholderDance25: "Sube recursos de referencia. Escribe texto y usa {'@'}recursos para combinarlos libremente. Ejemplo: {'@'}Imagen1 imita {'@'}Video1 usando {'@'}Audio1.",
            promptMaxLength: 'El prompt no puede superar los {count} caracteres.',
            imageMaxCount: 'Puedes subir hasta {count} imágenes de referencia.',
            videoDurationRange: 'Este video dura {current}. Sube un video de entre {min} y {max} segundos.',
            videoMaxCount: 'Puedes subir hasta {count} videos de referencia.',
            videoTotalDuration: 'La duración total del video después de subirlo sería de {current}, lo que supera el límite de {max} segundos.',
            audioDurationRange: 'Este audio dura {current}. Sube un audio de entre {min} y {max} segundos.',
            audioMaxCount: 'Puedes subir hasta {count} audios de referencia.',
            audioTotalDuration: 'La duración total del audio después de subirlo sería de {current}, lo que supera el límite de {max} segundos.',
            mediaTotalDuration: 'La duración total de los videos y audios de referencia después de subirlos sería de {current}, lo que supera el límite de {max} segundos.',
            audioNeedsVisualReference: 'El audio no puede usarse solo. Conserva al menos una imagen o un video de referencia.',
            referenceRequired: 'Sube al menos una imagen o un video de referencia.',
            uploadHints: {
                image: 'Admite 1-9 imagenes, hasta 3 videos y hasta 3 audios (cada uno de 2-15 s; los totales de video y audio se calculan por separado, cada uno <= 15 s)',
                dance25: 'Admite hasta {imageCount} imagenes, {videoCount} videos y {audioCount} audios (cada video/audio de {minDuration}-{maxDuration} s; los totales de video y audio se calculan por separado, cada uno <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Eliminar vídeo',
            removeImage: 'Eliminar imagen',
            removeAudio: 'Eliminar audio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitación de movimiento de vídeo con IA',
            'video-face-swap': 'Intercambio de rostro en vídeo con IA',
            'video-to-anime': 'Convertidor de vídeo a anime con IA',
            'video-subtitle-translate': 'Traducción de subtítulos con IA',
            'video-upscaler': 'Mejora de vídeo con IA',
            'video-background-remover': 'Eliminación de fondo de vídeo con IA',
            'video-watermark-remover': 'Eliminador de marca de agua con IA',
            'remove-video-subtitles': 'Eliminación de subtítulos con IA',
            'video-extender': 'Extensor de vídeo con IA',
            'image-background-changer': 'Cambiador de fondo de imagen con IA',
            'image-resizer': 'Redimensionador de imágenes con IA',
            'image-text-translate': 'Traducción de texto en imágenes con IA',
            'image-upscaler': 'Mejora de calidad de imagen con IA',
            'photo-face-swap': 'Reemplazo de rostro',
            'remove-text-image': 'Eliminación de texto en imágenes con IA',
            'ai-image-extender': 'Extensor de imágenes con IA',
            'photo-restoration': 'Restauración de fotos antiguas',
            'ai-image-background-remover': 'Eliminador de fondo de imagen con IA',
            'video-lip-sync': 'Sincronización labial de vídeo con IA',
        },
        // Mis Proyectos
        myProject: 'Mis Proyectos',
        noProject: 'Sin proyectos',
        newProject: 'Nuevo Proyecto',
        // Acciones hover del historial
        addToInput: 'Añadir a creación',
        reAdd: 'Volver a añadir',
        imageEdit: 'Editar imagen',
        videoEdit: 'Editar vídeo',
        videoToolCannotUploadImage: 'Las herramientas de edición de video solo pueden subir videos, no imágenes',
        videoEditOnlySupportVideo: 'La edición de video solo admite subir videos',
        videoAddedToTool: 'Video añadido a la herramienta',
        switchedToImageMode: 'Cambiado al modo imagen a imagen',
        switchedToVideoMode: 'Cambiado al modo de edición de video',
        reEdit: 'Reeditar',
        musicCannotReEdit: 'La creación de música no se puede reeditar',
    },
    fr: {
        importLink: 'Importer le lien',
        videoPreview: 'Aperçu vidéo',
        modeSelect: 'Sélection du mode',
        reselect: 'Resélectionner',
        select: 'Sélectionner',
        selectModel: 'Sélectionner un modèle',
        openQuickSwitches: 'Ouvrir les interrupteurs rapides',
        quickSettings: {
            openSettings: 'Ouvrir les paramètres',
            aspectRatio: 'Format',
            outputCount: 'Nombre de sorties',
            resolution: 'Résolution',
            duration: 'Durée',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Début',
        lastFrame: 'Fin',
        keyframesUpload: {
            firstFrameAlt: 'Première image',
            lastFrameAlt: 'Dernière image',
            removeFirstFrame: 'Supprimer la première image',
            removeLastFrame: 'Supprimer la dernière image',
        },
        toolOptions: {
            mode: 'Mode',
            backgroundColor: 'Couleur d’arrière-plan',
            outputFormat: 'Format de sortie',
            type: 'Type',
            extendDuration: 'Durée d’extension',
            backgroundDescription: 'Description de l’arrière-plan',
            aspectRatio: 'Format',
            translateTo: 'Traduire en',
        },
        toolOptionValues: {
            motionType: {
                move: 'Piloté par mouvement',
                replace: 'Remplacement de personnage',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animation 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Bande dessinée',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Décrivez dans le prompt le contenu à prolonger dans la vidéo...',
        },
        languageNames: {
            zh: 'Chinois (simplifié)',
            tw: 'Chinois (traditionnel)',
            en: 'Anglais',
            ja: 'Japonais',
            ko: 'Coréen',
            es: 'Espagnol',
            fr: 'Français',
            de: 'Allemand',
            ru: 'Russe',
            pl: 'Polonais',
            pt: 'Portugais',
            it: 'Italien',
            ar: 'Arabe',
            th: 'Thaï',
            da: 'Danois',
            no: 'Norvégien (Bokmål)',
            nl: 'Néerlandais',
            id: 'Indonésien',
            tr: 'Turc',
        },
        promptPlaceholder: 'Décrivez ce que vous voulez générer',
        modePromptPlaceholders: {
            chat: 'De quoi voulez-vous parler ou que voulez-vous faire ?',
            image: 'Décrivez l’image que vous voulez générer, comme le sujet, le style et la scène',
            video: 'Décrivez la vidéo que vous voulez générer, comme les plans, le mouvement et la scène',
            music: 'Décrivez le style musical, l’ambiance ou le thème',
        },
        promptPlaceholderToday: "Que souhaitez-vous générer aujourd'hui ?",
        positivePrompt: 'Prompt positif',
        negativePrompt: 'Prompt négatif',
        negativePromptPlaceholder: 'Saisissez le prompt négatif',
        videoModeMulti: 'Génération multi-images',
        videoModeAddLastFrame: 'Ajouter la dernière image',
        credits: '{count}',
        uploadingWait: 'Téléchargement en cours, veuillez patienter avant de coller.',
        noEmptySlot: 'Aucun emplacement vide disponible pour coller des images.',
        maxPasteLimit: 'Vous pouvez téléverser jusqu’à {count} fichiers.',
        formatSupport: 'Le mode de création actuel ne prend pas en charge ce type de fichier : ',
        andOthers: ' et {count} autres fichiers',
        notSupportPaste: 'L\'outil actuel ne permet pas de coller des images.',
        onlyOneVideo: 'Un seul fichier vidéo peut être téléchargé.',
        videoTooLargePrompt: 'Le fichier vidéo est trop volumineux, veuillez télécharger une vidéo de moins de {size}.',
        templateSlotLimit: 'Chaque emplacement de modèle ne supporte qu\'une seule image.',
        uploadingWaitDrag: 'Téléchargement en cours, veuillez patienter avant de faire glisser.',
        uploadTypeCheck: 'Le mode de création actuel ne prend pas en charge ce type de fichier.',
        imageSizeLimitPrompt: 'La taille de l\'image ne peut pas dépasser 100 Mo.',
        imageResolutionLimitPrompt: 'La résolution de l\'image est trop élevée, le côté le plus long ne peut pas dépasser 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Image',
            videoGenerate: 'Vidéo',
            musicGenerate: 'Musique',
            imageEdit: 'Édition d\'image',
            videoEdit: 'Édition vidéo',
            imageTemplate: 'Modèles d\'image',
            videoTemplate: 'Modèles vidéo',
            tools: 'Outils',
        },
        secondaryTabs: {
            textToImage: 'Texte vers image',
            imageToImage: 'Image vers image',
            characterToImage: 'Personnage vers image',
            textToVideo: 'Texte vers vidéo',
            imageToVideo: 'Image vers vidéo',
            keyframes: 'Première/dernière image',
            characterToVideo: 'Personnage vers vidéo',
            videoEdit: 'Édition vidéo',
            voice: 'Voix',
            pureMusic: 'Musique instrumentale',
        },
        seedanceVideoModes: {
            allRound: 'Reference polyvalente',
        },
        tertiaryTabs: {
            boyVoice: 'Voix masculine',
            girlVoice: 'Voix féminine',
        },
        configGroups: {
            voiceGender: 'Type de voix',
            tags: 'Tags',
        },
        audioGenerated: 'Audio généré',
        successAudioLinkAdded: 'Lien audio ajouté',
        audio: 'Audio',
        audioLink: 'Lien audio',
        uploadAudio: 'Télécharger audio',
        addAudio: 'Ajouter audio',
        musicPrompt: {
            removeTag: 'Supprimer l’étiquette',
            creativeThemeTitle: 'Thème créatif',
            creativeThemePlaceholder:
                'Décrivez le style, l’ambiance ou le thème de la musique',
            lyricsTitle: 'Saisir les paroles',
            lyricsPlaceholder: 'Saisir les paroles...',
        },
        uploadLabels: {
            video: 'Vidéo',
            image: 'Image',
            audio: 'Audio',
            baseImage: 'Image de base',
            face: 'Visage',
        },
        seedanceAlmighty: {
            panelTitle: 'Contenu de reference',
            emptyTitle: 'Televerser des references',
            dragMaterialsHere: 'Glissez les éléments ici',
            promptPlaceholder: "Televersez 1 a 12 elements de reference. Saisissez du texte et ajoutez des {'@'}references pour les combiner librement. Exemple : {'@'}Image1 imite {'@'}Video1 avec {'@'}Audio1.",
            promptPlaceholderDance25: "Televersez des elements de reference. Saisissez du texte et ajoutez des {'@'}references pour les combiner librement. Exemple : {'@'}Image1 imite {'@'}Video1 avec {'@'}Audio1.",
            promptMaxLength: 'Le prompt ne doit pas dépasser {count} caractères.',
            imageMaxCount: 'Vous pouvez téléverser jusqu à {count} images de référence.',
            videoDurationRange: 'Cette vidéo dure {current}. Veuillez televerser une vidéo de {min} à {max} secondes.',
            videoMaxCount: 'Vous pouvez téléverser jusqu à {count} vidéos de référence.',
            videoTotalDuration: 'Après televersement, la durée totale des vidéos serait de {current}, ce qui dépasse la limite de {max} secondes.',
            audioDurationRange: 'Cet audio dure {current}. Veuillez televerser un audio de {min} à {max} secondes.',
            audioMaxCount: 'Vous pouvez téléverser jusqu à {count} audios de référence.',
            audioTotalDuration: 'Après televersement, la durée totale des audios serait de {current}, ce qui dépasse la limite de {max} secondes.',
            mediaTotalDuration: 'Après téléversement, la durée totale des vidéos et audios de référence serait de {current}, ce qui dépasse la limite de {max} secondes.',
            audioNeedsVisualReference: 'L audio ne peut pas être utilisé seul. Conservez au moins une image ou une vidéo de référence.',
            referenceRequired: 'Téléversez au moins une image ou une vidéo de référence.',
            uploadHints: {
                image: 'Prend en charge 1 a 9 images, jusqu a 3 videos et jusqu a 3 audios (2 a 15 s chacun; les durees video et audio sont calculees separement, chacune <= 15 s)',
                dance25: 'Prend en charge jusqu a {imageCount} images, {videoCount} videos et {audioCount} audios (chaque video/audio de {minDuration} a {maxDuration} s; les durees video et audio sont calculees separement, chacune <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Supprimer la vidéo',
            removeImage: 'Supprimer l’image',
            removeAudio: 'Supprimer l audio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitation de mouvement vidéo par IA',
            'video-face-swap': 'Échange de visage vidéo par IA',
            'video-to-anime': 'Convertisseur vidéo en anime par IA',
            'video-subtitle-translate': 'Traduction de sous-titres par IA',
            'video-upscaler': 'Amélioration vidéo par IA',
            'video-background-remover': 'Suppression de l’arrière-plan vidéo par IA',
            'video-watermark-remover': 'Suppresseur de filigrane par IA',
            'remove-video-subtitles': 'Suppression de sous-titres par IA',
            'video-extender': 'Prolongateur vidéo par IA',
            'image-background-changer': 'Changeur d’arrière-plan d’image par IA',
            'image-resizer': 'Redimensionneur d’image par IA',
            'image-text-translate': 'Traduction de texte d’image par IA',
            'image-upscaler': 'Amélioration de la qualité d’image par IA',
            'photo-face-swap': 'Remplacement de visage',
            'remove-text-image': 'Suppression de texte d’image par IA',
            'ai-image-extender': 'Extension d’image par IA',
            'photo-restoration': 'Restauration de vieilles photos',
            'ai-image-background-remover': 'Suppression de l’arrière-plan d’image par IA',
            'video-lip-sync': 'Synchronisation labiale vidéo par IA',
        },
        // Mes Projets
        myProject: 'Mes Projets',
        noProject: 'Aucun projet',
        newProject: 'Nouveau Projet',
        // Actions au survol de l'historique
        addToInput: 'Ajouter à la création',
        reAdd: 'Ré-ajouter',
        imageEdit: 'Éditer l\'image',
        videoEdit: 'Éditer la vidéo',
        videoToolCannotUploadImage: 'Les outils d\'édition vidéo ne peuvent télécharger que des vidéos, pas des images',
        videoEditOnlySupportVideo: 'L\'édition vidéo ne prend en charge que le téléchargement de vidéos',
        videoAddedToTool: 'Vidéo ajoutée à l\'outil',
        switchedToImageMode: 'Basculé en mode image vers image',
        switchedToVideoMode: 'Basculé en mode d\'édition vidéo',
        reEdit: 'Rééditer',
        musicCannotReEdit: 'La création musicale ne peut pas être rééditée',
    },
    de: {
        importLink: 'Link importieren',
        videoPreview: 'Videovorschau',
        modeSelect: 'Modusauswahl',
        reselect: 'Neu auswählen',
        select: 'Auswählen',
        selectModel: 'Modell auswählen',
        openQuickSwitches: 'Schnellschalter öffnen',
        quickSettings: {
            openSettings: 'Einstellungen öffnen',
            aspectRatio: 'Seitenverhältnis',
            outputCount: 'Ausgabeanzahl',
            resolution: 'Auflösung',
            duration: 'Dauer',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Start',
        lastFrame: 'Ende',
        keyframesUpload: {
            firstFrameAlt: 'Erstes Bild',
            lastFrameAlt: 'Letztes Bild',
            removeFirstFrame: 'Erstes Bild entfernen',
            removeLastFrame: 'Letztes Bild entfernen',
        },
        toolOptions: {
            mode: 'Modus',
            backgroundColor: 'Hintergrundfarbe',
            outputFormat: 'Ausgabeformat',
            type: 'Typ',
            extendDuration: 'Verlängerungsdauer',
            backgroundDescription: 'Hintergrundbeschreibung',
            aspectRatio: 'Seitenverhältnis',
            translateTo: 'Übersetzen nach',
        },
        toolOptionValues: {
            motionType: {
                move: 'Bewegungssteuerung',
                replace: 'Charaktertausch',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D-Animation',
                cyberpunk: 'Cyberpunk',
                comic: 'Comic',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Beschreibe im Prompt, was im Video verlängert werden soll...',
        },
        languageNames: {
            zh: 'Chinesisch (Vereinfacht)',
            tw: 'Chinesisch (Traditionell)',
            en: 'Englisch',
            ja: 'Japanisch',
            ko: 'Koreanisch',
            es: 'Spanisch',
            fr: 'Französisch',
            de: 'Deutsch',
            ru: 'Russisch',
            pl: 'Polnisch',
            pt: 'Portugiesisch',
            it: 'Italienisch',
            ar: 'Arabisch',
            th: 'Thailändisch',
            da: 'Dänisch',
            no: 'Norwegisch (Bokmål)',
            nl: 'Niederländisch',
            id: 'Indonesisch',
            tr: 'Türkisch',
        },
        promptPlaceholder: 'Beschreibe, was du generieren möchtest',
        modePromptPlaceholders: {
            chat: 'Worüber möchtest du sprechen oder was möchtest du erledigen?',
            image: 'Beschreibe das Bild, das du generieren möchtest, zum Beispiel Motiv, Stil und Szene',
            video: 'Beschreibe das Video, das du generieren möchtest, zum Beispiel Einstellungen, Bewegung und Szene',
            music: 'Beschreibe den Musikstil, die Stimmung oder das Thema',
        },
        promptPlaceholderToday: 'Was möchtest du heute generieren?',
        positivePrompt: 'Positiver Prompt',
        negativePrompt: 'Negativer Prompt',
        negativePromptPlaceholder: 'Negativen Prompt eingeben',
        videoModeMulti: 'Mehrbild-Generierung',
        videoModeAddLastFrame: 'Letztes Bild hinzufügen',
        credits: '{count}',
        uploadingWait: 'Wird hochgeladen, bitte warten Sie bis zum Abschluss, bevor Sie einfügen.',
        noEmptySlot: 'Keine leeren Plätze zum Einfügen von Bildern verfügbar.',
        maxPasteLimit: 'Du kannst bis zu {count} Dateien hochladen.',
        formatSupport: 'Der aktuelle Erstellungsmodus unterstützt diesen Dateityp nicht: ',
        andOthers: ' und {count} weitere Dateien',
        notSupportPaste: 'Das aktuelle Werkzeug unterstützt das Einfügen von Bildern nicht.',
        onlyOneVideo: 'Es kann nur 1 Videodatei hochgeladen werden.',
        videoTooLargePrompt: 'Die Videodatei ist zu groß, bitte laden Sie ein Video innerhalb von {size} hoch.',
        templateSlotLimit: 'Jeder Vorlagenplatz unterstützt nur 1 Bild.',
        uploadingWaitDrag: 'Wird hochgeladen, bitte warten Sie bis zum Abschluss, bevor Sie ziehen.',
        uploadTypeCheck: 'Der aktuelle Erstellungsmodus unterstützt diesen Dateityp nicht.',
        imageSizeLimitPrompt: 'Die Bildgröße darf 100 MB nicht überschreiten.',
        imageResolutionLimitPrompt: 'Die Bildauflösung ist zu groß, die längste Seite darf 4096 px nicht überschreiten.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Bild',
            videoGenerate: 'Video',
            musicGenerate: 'Musik',
            imageEdit: 'Bildbearbeitung',
            videoEdit: 'Videobearbeitung',
            imageTemplate: 'Bildvorlagen',
            videoTemplate: 'Videovorlagen',
            tools: 'Werkzeuge',
        },
        secondaryTabs: {
            textToImage: 'Text zu Bild',
            imageToImage: 'Bild zu Bild',
            characterToImage: 'Charakter zu Bild',
            textToVideo: 'Text zu Video',
            imageToVideo: 'Bild zu Video',
            keyframes: 'Erstes/letztes Frame',
            characterToVideo: 'Charakter zu Video',
            videoEdit: 'Videobearbeitung',
            voice: 'Gesang',
            pureMusic: 'Instrumental',
        },
        seedanceVideoModes: {
            allRound: 'Allround-Referenz',
        },
        tertiaryTabs: {
            boyVoice: 'Männliche Stimme',
            girlVoice: 'Weibliche Stimme',
        },
        configGroups: {
            voiceGender: 'Stimmtyp',
            tags: 'Tags',
        },
        audioGenerated: 'Audio generiert',
        successAudioLinkAdded: 'Audio-Link hinzugefügt',
        audio: 'Audio',
        audioLink: 'Audio-Link',
        uploadAudio: 'Audio hochladen',
        addAudio: 'Audio hinzufügen',
        musicPrompt: {
            removeTag: 'Tag entfernen',
            creativeThemeTitle: 'Kreatives Thema',
            creativeThemePlaceholder: 'Beschreibe Musikstil, Stimmung oder Thema',
            lyricsTitle: 'Songtext eingeben',
            lyricsPlaceholder: 'Songtext eingeben...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Bild',
            audio: 'Audio',
            baseImage: 'Basisbild',
            face: 'Gesicht',
        },
        seedanceAlmighty: {
            panelTitle: 'Referenzinhalt',
            emptyTitle: 'Referenzen hochladen',
            dragMaterialsHere: 'Materialien hierher ziehen',
            promptPlaceholder: "Laden Sie 1-12 Referenzmedien hoch. Geben Sie Text ein und markieren Sie {'@'}Medien, um sie frei zu kombinieren. Beispiel: {'@'}Bild1 ahmt {'@'}Video1 mit {'@'}Audio1 nach.",
            promptPlaceholderDance25: "Laden Sie Referenzmedien hoch. Geben Sie Text ein und markieren Sie {'@'}Medien, um sie frei zu kombinieren. Beispiel: {'@'}Bild1 ahmt {'@'}Video1 mit {'@'}Audio1 nach.",
            promptMaxLength: 'Der Prompt darf höchstens {count} Zeichen lang sein.',
            imageMaxCount: 'Sie können bis zu {count} Referenzbilder hochladen.',
            videoDurationRange: 'Dieses Referenzvideo ist {current} lang. Bitte laden Sie ein Video zwischen {min} und {max} Sekunden hoch.',
            videoMaxCount: 'Sie können bis zu {count} Referenzvideos hochladen.',
            videoTotalDuration: 'Die Gesamtdauer der Videos nach dem Upload wäre {current} und überschreitet damit das Limit von {max} Sekunden.',
            audioDurationRange: 'Diese Referenz-Audiodatei ist {current} lang. Bitte laden Sie eine Audiodatei zwischen {min} und {max} Sekunden hoch.',
            audioMaxCount: 'Sie können bis zu {count} Referenz-Audiodateien hochladen.',
            audioTotalDuration: 'Die Gesamtdauer der Audiodateien nach dem Upload wäre {current} und überschreitet damit das Limit von {max} Sekunden.',
            mediaTotalDuration: 'Die Gesamtdauer der Referenzvideos und Audiodateien nach dem Upload wäre {current} und überschreitet damit das Limit von {max} Sekunden.',
            audioNeedsVisualReference: 'Audio kann nicht allein verwendet werden. Behalten Sie mindestens ein Referenzbild oder Referenzvideo.',
            referenceRequired: 'Laden Sie mindestens ein Referenzbild oder Referenzvideo hoch.',
            uploadHints: {
                image: 'Unterstutzt 1-9 Bilder, bis zu 3 Videos und bis zu 3 Audiodateien (je 2-15 s; Video- und Audiogesamtdauer werden getrennt berechnet, jeweils <= 15 s)',
                dance25: 'Unterstutzt bis zu {imageCount} Bilder, {videoCount} Videos und {audioCount} Audiodateien (je Video/Audio {minDuration}-{maxDuration} s; Video- und Audiogesamtdauer werden getrennt berechnet, jeweils <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Video entfernen',
            removeImage: 'Bild entfernen',
            removeAudio: 'Audio entfernen',
        },
        toolTitles: {
            'video-motion-imitation': 'KI-Video-Bewegungsimitation',
            'video-face-swap': 'KI-Video-Gesichtstausch',
            'video-to-anime': 'KI-Video-zu-Anime-Konverter',
            'video-subtitle-translate': 'KI-Untertitelübersetzung',
            'video-upscaler': 'KI-Video-Verbesserung',
            'video-background-remover': 'KI-Video-Hintergrundentfernung',
            'video-watermark-remover': 'KI-Wasserzeichenentferner',
            'remove-video-subtitles': 'KI-Untertitelentfernung',
            'video-extender': 'KI-Video-Verlängerer',
            'image-background-changer': 'KI-Bild-Hintergrundwechsler',
            'image-resizer': 'KI-Bildgrößenanpassung',
            'image-text-translate': 'KI-Bildtextübersetzung',
            'image-upscaler': 'KI-Bildqualitätsverbesserung',
            'photo-face-swap': 'Gesichtsersetzung',
            'remove-text-image': 'KI-Bildtextentfernung',
            'ai-image-extender': 'KI-Bilderweiterung',
            'photo-restoration': 'Alte-Foto-Restaurierung',
            'ai-image-background-remover': 'KI-Bild-Hintergrundentferner',
            'video-lip-sync': 'KI-Video-Lippensynchronisation',
        },
        // Meine Projekte
        myProject: 'Meine Projekte',
        noProject: 'Keine Projekte',
        newProject: 'Neues Projekt',
        // Verlauf-Hover-Aktionen
        addToInput: 'Zur Erstellung hinzufügen',
        reAdd: 'Erneut hinzufügen',
        imageEdit: 'Bild bearbeiten',
        videoEdit: 'Video bearbeiten',
        videoToolCannotUploadImage: 'Video-Bearbeitungstools können nur Videos hochladen, keine Bilder',
        videoEditOnlySupportVideo: 'Videobearbeitung unterstützt nur das Hochladen von Videos',
        videoAddedToTool: 'Video zum Tool hinzugefügt',
        switchedToImageMode: 'Zum Bild-zu-Bild-Modus gewechselt',
        switchedToVideoMode: 'Zum Videobearbeitungsmodus gewechselt',
        reEdit: 'Erneut bearbeiten',
        musicCannotReEdit: 'Musikkreation kann nicht erneut bearbeitet werden',
    },
    ru: {
        importLink: 'Импорт ссылки',
        videoPreview: 'Предпросмотр видео',
        modeSelect: 'Выбор режима',
        reselect: 'Выбрать снова',
        select: 'Выбрать',
        selectModel: 'Выбрать модель',
        openQuickSwitches: 'Открыть быстрые переключатели',
        quickSettings: {
            openSettings: 'Открыть настройки',
            aspectRatio: 'Соотношение сторон',
            outputCount: 'Количество результатов',
            resolution: 'Разрешение',
            duration: 'Длительность',
            secondsLabel: '{value}с',
        },
        avatar: 'Аватар',
        firstFrame: 'Старт',
        lastFrame: 'Конец',
        keyframesUpload: {
            firstFrameAlt: 'Первый кадр',
            lastFrameAlt: 'Последний кадр',
            removeFirstFrame: 'Удалить первый кадр',
            removeLastFrame: 'Удалить последний кадр',
        },
        toolOptions: {
            mode: 'Режим',
            backgroundColor: 'Цвет фона',
            outputFormat: 'Формат вывода',
            type: 'Тип',
            extendDuration: 'Длительность продления',
            backgroundDescription: 'Описание фона',
            aspectRatio: 'Соотношение сторон',
            translateTo: 'Перевести на',
        },
        toolOptionValues: {
            motionType: {
                move: 'Управление движением',
                replace: 'Замена персонажа',
            },
            videoExtenderStyle: {
                anime: 'Аниме',
                '3dAnimation': '3D-анимация',
                cyberpunk: 'Киберпанк',
                comic: 'Комикс',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Опишите в промпте, что нужно продлить в видео...',
        },
        languageNames: {
            zh: 'Китайский (упрощённый)',
            tw: 'Китайский (традиционный)',
            en: 'Английский',
            ja: 'Японский',
            ko: 'Корейский',
            es: 'Испанский',
            fr: 'Французский',
            de: 'Немецкий',
            ru: 'Русский',
            pl: 'Польский',
            pt: 'Португальский',
            it: 'Итальянский',
            ar: 'Арабский',
            th: 'Тайский',
            da: 'Датский',
            no: 'Норвежский (букмол)',
            nl: 'Нидерландский',
            id: 'Индонезийский',
            tr: 'Турецкий',
        },
        promptPlaceholder: 'Опишите, что вы хотите сгенерировать',
        modePromptPlaceholders: {
            chat: 'О чем вы хотите поговорить или что хотите сделать?',
            image: 'Опишите изображение, которое хотите создать: объект, стиль и сцену',
            video: 'Опишите видео, которое хотите создать: планы, движение и сцену',
            music: 'Опишите музыкальный стиль, настроение или тему',
        },
        promptPlaceholderToday: 'Что вы хотите сгенерировать сегодня?',
        positivePrompt: 'Позитивный промпт',
        negativePrompt: 'Негативный промпт',
        negativePromptPlaceholder: 'Введите негативный промпт',
        videoModeMulti: 'Генерация по нескольким изображениям',
        videoModeAddLastFrame: 'Добавить последний кадр',
        credits: '{count}',
        uploadingWait: 'Загрузка, пожалуйста, подождите завершения перед вставкой.',
        noEmptySlot: 'Нет свободных слотов для вставки изображений.',
        maxPasteLimit: 'Можно загрузить не более {count} файлов.',
        formatSupport: 'Текущий режим создания не поддерживает этот тип файла: ',
        andOthers: ' и еще {count} файлов',
        notSupportPaste: 'Текущий инструмент не поддерживает вставку изображений.',
        onlyOneVideo: 'Можно загрузить только 1 видеофайл.',
        videoTooLargePrompt: 'Видеофайл слишком велик, пожалуйста, загрузите видео размером до {size}.',
        templateSlotLimit: 'Каждый слот шаблона поддерживает только 1 изображение.',
        uploadingWaitDrag: 'Загрузка, пожалуйста, подождите завершения перед перетаскиванием.',
        uploadTypeCheck: 'Текущий режим создания не поддерживает этот тип файла.',
        imageSizeLimitPrompt: 'Размер изображения не может превышать 100 МБ.',
        imageResolutionLimitPrompt: 'Разрешение изображения слишком велико, самая длинная сторона не может превышать 4096 пикс.',
        primaryTabs: {
            chat: 'Чат',
            imageGenerate: 'Изображение',
            videoGenerate: 'Видео',
            musicGenerate: 'Музыка',
            imageEdit: 'Редактирование изображений',
            videoEdit: 'Редактирование видео',
            imageTemplate: 'Шаблоны изображений',
            videoTemplate: 'Шаблоны видео',
            tools: 'Инструменты',
        },
        secondaryTabs: {
            textToImage: 'Текст в изображение',
            imageToImage: 'Изображение в изображение',
            characterToImage: 'Персонаж в изображение',
            textToVideo: 'Текст в видео',
            imageToVideo: 'Изображение в видео',
            keyframes: 'Первый/последний кадр',
            characterToVideo: 'Персонаж в видео',
            videoEdit: 'Редактирование видео',
            voice: 'Вокал',
            pureMusic: 'Инструментальная музыка',
        },
        seedanceVideoModes: {
            allRound: 'Универсальный референс',
        },
        tertiaryTabs: {
            boyVoice: 'Мужской голос',
            girlVoice: 'Женский голос',
        },
        configGroups: {
            voiceGender: 'Тип голоса',
            tags: 'Теги',
        },
        audioGenerated: 'Аудио сгенерировано',
        successAudioLinkAdded: 'Аудиоссылка добавлена',
        audio: 'Аудио',
        audioLink: 'Аудиоссылка',
        uploadAudio: 'Загрузить аудио',
        addAudio: 'Добавить аудио',
        musicPrompt: {
            removeTag: 'Удалить тег',
            creativeThemeTitle: 'Творческая тема',
            creativeThemePlaceholder:
                'Опишите стиль, настроение или тему музыки',
            lyricsTitle: 'Введите текст песни',
            lyricsPlaceholder: 'Введите текст песни...',
        },
        uploadLabels: {
            video: 'Видео',
            image: 'Изображение',
            audio: 'Аудио',
            baseImage: 'Базовое изображение',
            face: 'Лицо',
        },
        seedanceAlmighty: {
            panelTitle: 'Справочный контент',
            emptyTitle: 'Загрузить референсы',
            dragMaterialsHere: 'Перетащите материалы сюда',
            promptPlaceholder: "Загрузите 1-12 референсов. Введите текст и добавьте {'@'}материалы, чтобы свободно их сочетать. Пример: {'@'}Изображение1 повторяет {'@'}Видео1 с {'@'}Аудио1.",
            promptPlaceholderDance25: "Загрузите референсы. Введите текст и добавьте {'@'}материалы, чтобы свободно их сочетать. Пример: {'@'}Изображение1 повторяет {'@'}Видео1 с {'@'}Аудио1.",
            promptMaxLength: 'Подсказка не должна превышать {count} символов.',
            imageMaxCount: 'Можно загрузить не более {count} референсных изображений.',
            videoDurationRange: 'Длительность этого референсного видео составляет {current}. Загрузите видео длительностью от {min} до {max} секунд.',
            videoMaxCount: 'Можно загрузить не более {count} референсных видео.',
            videoTotalDuration: 'Общая длительность видео после загрузки составит {current}, что превышает лимит в {max} секунд.',
            audioDurationRange: 'Длительность этого референсного аудио составляет {current}. Загрузите аудио длительностью от {min} до {max} секунд.',
            audioMaxCount: 'Можно загрузить не более {count} референсных аудио.',
            audioTotalDuration: 'Общая длительность аудио после загрузки составит {current}, что превышает лимит в {max} секунд.',
            mediaTotalDuration: 'Общая длительность референсных видео и аудио после загрузки составит {current}, что превышает лимит в {max} секунд.',
            audioNeedsVisualReference: 'Аудио нельзя использовать отдельно. Оставьте хотя бы одно референсное изображение или видео.',
            referenceRequired: 'Загрузите хотя бы одно референсное изображение или видео.',
            uploadHints: {
                image: 'Поддерживается загрузка 1-9 изображений, до 3 видео и до 3 аудио (каждый файл 2-15 с; общая длительность видео и аудио считается отдельно, каждая <= 15 с)',
                dance25: 'Поддерживается до {imageCount} изображений, {videoCount} видео и {audioCount} аудио (каждое видео/аудио {minDuration}-{maxDuration} с; общая длительность видео и аудио считается отдельно, каждая <= {totalDuration} с)',
            },
        },
        uploadStrip: {
            removeVideo: 'Удалить видео',
            removeImage: 'Удалить изображение',
            removeAudio: 'Удалить аудио',
        },
        toolTitles: {
            'video-motion-imitation': 'ИИ имитация движений видео',
            'video-face-swap': 'ИИ замена лица в видео',
            'video-to-anime': 'ИИ конвертер видео в аниме',
            'video-subtitle-translate': 'ИИ перевод субтитров',
            'video-upscaler': 'ИИ улучшение видео',
            'video-background-remover': 'ИИ удаление фона видео',
            'video-watermark-remover': 'ИИ удаление водяных знаков',
            'remove-video-subtitles': 'ИИ удаление субтитров',
            'video-extender': 'ИИ продление видео',
            'image-background-changer': 'ИИ смена фона изображения',
            'image-resizer': 'ИИ изменение размера изображения',
            'image-text-translate': 'ИИ перевод текста на изображении',
            'image-upscaler': 'ИИ улучшение качества изображения',
            'photo-face-swap': 'Замена лица',
            'remove-text-image': 'ИИ удаление текста с изображения',
            'ai-image-extender': 'ИИ расширение изображения',
            'photo-restoration': 'Реставрация старых фото',
            'ai-image-background-remover': 'ИИ удаление фона изображения',
            'video-lip-sync': 'ИИ синхронизация губ в видео',
        },
        // Мои проекты
        myProject: 'Мои проекты',
        noProject: 'Нет проектов',
        newProject: 'Новый проект',
        // Действия при наведении на историю
        addToInput: 'Добавить к созданию',
        reAdd: 'Добавить снова',
        imageEdit: 'Редактировать изображение',
        videoEdit: 'Редактировать видео',
        videoToolCannotUploadImage: 'Инструменты редактирования видео могут загружать только видео, а не изображения',
        videoEditOnlySupportVideo: 'Редактирование видео поддерживает только загрузку видео',
        videoAddedToTool: 'Видео добавлено в инструмент',
        switchedToImageMode: 'Переключено в режим изображение в изображение',
        switchedToVideoMode: 'Переключено в режим редактирования видео',
        reEdit: 'Повторное редактирование',
        musicCannotReEdit: 'Музыкальное творчество нельзя редактировать повторно',
    },
    pl: {
        importLink: 'Importuj link',
        videoPreview: 'Podgląd wideo',
        modeSelect: 'Wybór trybu',
        reselect: 'Wybierz ponownie',
        select: 'Wybierz',
        selectModel: 'Wybierz model',
        openQuickSwitches: 'Otwórz szybkie przełączniki',
        quickSettings: {
            openSettings: 'Otwórz ustawienia',
            aspectRatio: 'Proporcje',
            outputCount: 'Liczba wyników',
            resolution: 'Rozdzielczość',
            duration: 'Czas trwania',
            secondsLabel: '{value}s',
        },
        avatar: 'Awatar',
        firstFrame: 'Start',
        lastFrame: 'Koniec',
        keyframesUpload: {
            firstFrameAlt: 'Pierwsza klatka',
            lastFrameAlt: 'Ostatnia klatka',
            removeFirstFrame: 'Usuń pierwszą klatkę',
            removeLastFrame: 'Usuń ostatnią klatkę',
        },
        toolOptions: {
            mode: 'Tryb',
            backgroundColor: 'Kolor tła',
            outputFormat: 'Format wyjściowy',
            type: 'Typ',
            extendDuration: 'Czas wydłużenia',
            backgroundDescription: 'Opis tła',
            aspectRatio: 'Proporcje',
            translateTo: 'Tłumacz na',
        },
        toolOptionValues: {
            motionType: {
                move: 'Sterowanie ruchem',
                replace: 'Zamiana postaci',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animacja 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Komiks',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Opisz w promptcie, co chcesz wydłużyć w wideo...',
        },
        languageNames: {
            zh: 'Chiński (uproszczony)',
            tw: 'Chiński (tradycyjny)',
            en: 'Angielski',
            ja: 'Japoński',
            ko: 'Koreański',
            es: 'Hiszpański',
            fr: 'Francuski',
            de: 'Niemiecki',
            ru: 'Rosyjski',
            pl: 'Polski',
            pt: 'Portugalski',
            it: 'Włoski',
            ar: 'Arabski',
            th: 'Tajski',
            da: 'Duński',
            no: 'Norweski (Bokmål)',
            nl: 'Niderlandzki',
            id: 'Indonezyjski',
            tr: 'Turecki',
        },
        promptPlaceholder: 'Opisz, co chcesz wygenerować',
        modePromptPlaceholders: {
            chat: 'O czym chcesz porozmawiać lub co chcesz zrobić?',
            image: 'Opisz obraz, który chcesz wygenerować, na przykład temat, styl i scenę',
            video: 'Opisz wideo, które chcesz wygenerować, na przykład ujęcia, ruch i scenę',
            music: 'Opisz styl muzyczny, nastrój lub temat',
        },
        promptPlaceholderToday: 'Co chcesz dziś wygenerować?',
        positivePrompt: 'Pozytywny prompt',
        negativePrompt: 'Negatywny prompt',
        negativePromptPlaceholder: 'Wpisz negatywny prompt',
        videoModeMulti: 'Generowanie z wielu obrazów',
        videoModeAddLastFrame: 'Dodaj ostatnią klatkę',
        credits: '{count}',
        uploadingWait: 'Przesyłanie, poczekaj na zakończenie przed wklejeniem.',
        noEmptySlot: 'Brak wolnych miejsc na wklejenie obrazów.',
        maxPasteLimit: 'Możesz przesłać maksymalnie {count} plików.',
        formatSupport: 'Bieżący tryb tworzenia nie obsługuje tego typu pliku: ',
        andOthers: ' i {count} innych plików',
        notSupportPaste: 'Bieżące narzędzie nie obsługuje wklejania obrazów.',
        onlyOneVideo: 'Można przesłać tylko 1 plik wideo.',
        videoTooLargePrompt: 'Plik wideo jest zbyt duży, prześlij wideo o rozmiarze do {size}.',
        templateSlotLimit: 'Każde miejsce w szablonie obsługuje tylko 1 obraz.',
        uploadingWaitDrag: 'Przesyłanie, poczekaj na zakończenie przed przeciągnięciem.',
        uploadTypeCheck: 'Bieżący tryb tworzenia nie obsługuje tego typu pliku.',
        imageSizeLimitPrompt: 'Rozmiar obrazu nie może przekroczyć 100 MB.',
        imageResolutionLimitPrompt: 'Rozdzielczość obrazu jest zbyt duża, najdłuższy bok nie może przekroczyć 4096 px.',
        primaryTabs: {
            chat: 'Czat',
            imageGenerate: 'Obraz',
            videoGenerate: 'Wideo',
            musicGenerate: 'Muzyka',
            imageEdit: 'Edycja obrazu',
            videoEdit: 'Edycja wideo',
            imageTemplate: 'Szablony obrazów',
            videoTemplate: 'Szablony wideo',
            tools: 'Narzędzia',
        },
        secondaryTabs: {
            textToImage: 'Tekst na obraz',
            imageToImage: 'Obraz na obraz',
            characterToImage: 'Postać na obraz',
            textToVideo: 'Tekst na wideo',
            imageToVideo: 'Obraz na wideo',
            keyframes: 'Pierwsza/ostatnia klatka',
            characterToVideo: 'Postać na wideo',
            videoEdit: 'Edycja wideo',
            voice: 'Wokal',
            pureMusic: 'Muzyka instrumentalna',
        },
        seedanceVideoModes: {
            allRound: 'Referencja uniwersalna',
        },
        tertiaryTabs: {
            boyVoice: 'Męski głos',
            girlVoice: 'Żeński głos',
        },
        configGroups: {
            voiceGender: 'Typ głosu',
            tags: 'Tagi',
        },
        audioGenerated: 'Audio wygenerowane',
        successAudioLinkAdded: 'Link audio dodany',
        audio: 'Audio',
        audioLink: 'Link audio',
        uploadAudio: 'Prześlij audio',
        addAudio: 'Dodaj audio',
        musicPrompt: {
            removeTag: 'Usuń tag',
            creativeThemeTitle: 'Temat kreatywny',
            creativeThemePlaceholder: 'Opisz styl, nastrój lub temat muzyki',
            lyricsTitle: 'Wprowadź tekst',
            lyricsPlaceholder: 'Wprowadź tekst...',
        },
        uploadLabels: {
            video: 'Wideo',
            image: 'Obraz',
            audio: 'Audio',
            baseImage: 'Obraz bazowy',
            face: 'Twarz',
        },
        seedanceAlmighty: {
            panelTitle: 'Tresc referencyjna',
            emptyTitle: 'Przeslij referencje',
            dragMaterialsHere: 'Przeciągnij materiały tutaj',
            promptPlaceholder: "Przeslij 1-12 materialow referencyjnych. Wpisz tekst i oznacz {'@'}materialy, aby laczyc je dowolnie. Przyklad: {'@'}Obraz1 nasladuje {'@'}Wideo1 z {'@'}Audio1.",
            promptPlaceholderDance25: "Przeslij materialy referencyjne. Wpisz tekst i oznacz {'@'}materialy, aby laczyc je dowolnie. Przyklad: {'@'}Obraz1 nasladuje {'@'}Wideo1 z {'@'}Audio1.",
            promptMaxLength: 'Prompt nie może przekraczać {count} znaków.',
            imageMaxCount: 'Możesz przesłać maksymalnie {count} obrazów referencyjnych.',
            videoDurationRange: 'To wideo referencyjne trwa {current}. Prześlij wideo o długości od {min} do {max} sekund.',
            videoMaxCount: 'Możesz przesłać maksymalnie {count} filmów referencyjnych.',
            videoTotalDuration: 'Łączny czas trwania wideo po przesłaniu wyniósłby {current}, co przekracza limit {max} sekund.',
            audioDurationRange: 'To audio referencyjne trwa {current}. Prześlij audio o długości od {min} do {max} sekund.',
            audioMaxCount: 'Możesz przesłać maksymalnie {count} nagrań audio referencyjnych.',
            audioTotalDuration: 'Łączny czas trwania audio po przesłaniu wyniósłby {current}, co przekracza limit {max} sekund.',
            mediaTotalDuration: 'Łączny czas trwania referencyjnych filmów i audio po przesłaniu wyniósłby {current}, co przekracza limit {max} sekund.',
            audioNeedsVisualReference: 'Audio nie może być użyte samodzielnie. Zachowaj co najmniej jeden obraz lub film referencyjny.',
            referenceRequired: 'Prześlij co najmniej jeden obraz lub film referencyjny.',
            uploadHints: {
                image: 'Obsluguje 1-9 obrazow, maksymalnie 3 wideo i maksymalnie 3 pliki audio (kazdy 2-15 s; laczny czas wideo i audio jest liczony osobno, kazdy <= 15 s)',
                dance25: 'Obsluguje do {imageCount} obrazow, {videoCount} wideo i {audioCount} plikow audio (kazde wideo/audio {minDuration}-{maxDuration} s; laczny czas wideo i audio jest liczony osobno, kazdy <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Usuń wideo',
            removeImage: 'Usuń obraz',
            removeAudio: 'Usuń audio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitacja ruchu wideo AI',
            'video-face-swap': 'Zmiana twarzy wideo AI',
            'video-to-anime': 'Konwerter wideo na anime AI',
            'video-subtitle-translate': 'Tłumaczenie napisów AI',
            'video-upscaler': 'Ulepszanie wideo AI',
            'video-background-remover': 'Usuwanie tła wideo AI',
            'video-watermark-remover': 'Usuwanie znaku wodnego AI',
            'remove-video-subtitles': 'Usuwanie napisów AI',
            'video-extender': 'Wydłużanie wideo AI',
            'image-background-changer': 'Zmieniacz tła obrazu AI',
            'image-resizer': 'Zmiana rozmiaru obrazu AI',
            'image-text-translate': 'Tłumaczenie tekstu na obrazie AI',
            'image-upscaler': 'Ulepszanie jakości obrazu AI',
            'photo-face-swap': 'Zamiana twarzy',
            'remove-text-image': 'Usuwanie tekstu z obrazu AI',
            'ai-image-extender': 'Rozszerzanie obrazu AI',
            'photo-restoration': 'Renowacja starych zdjęć',
            'ai-image-background-remover': 'Usuwanie tła obrazu AI',
            'video-lip-sync': 'Synchronizacja ruchu warg wideo AI',
        },
        // Moje projekty
        myProject: 'Moje projekty',
        noProject: 'Brak projektów',
        newProject: 'Nowy projekt',
        // Akcje najechania na historię
        addToInput: 'Dodaj do tworzenia',
        reAdd: 'Dodaj ponownie',
        imageEdit: 'Edytuj obraz',
        videoEdit: 'Edytuj wideo',
        videoToolCannotUploadImage: 'Narzędzia do edycji wideo mogą przesyłać tylko filmy, a nie obrazy',
        videoEditOnlySupportVideo: 'Edycja wideo obsługuje tylko przesyłanie filmów',
        videoAddedToTool: 'Wideo dodano do narzędzia',
        switchedToImageMode: 'Przełączono na tryb obraz na obraz',
        switchedToVideoMode: 'Przełączono na tryb edycji wideo',
        reEdit: 'Edytuj ponownie',
        musicCannotReEdit: 'Twórczość muzyczna nie może być ponownie edytowana',
    },
    pt: {
        importLink: 'Importar link',
        videoPreview: 'Pré-visualização do vídeo',
        modeSelect: 'Seleção de modo',
        reselect: 'Selecionar novamente',
        select: 'Selecionar',
        selectModel: 'Selecionar modelo',
        openQuickSwitches: 'Abrir alternâncias rápidas',
        quickSettings: {
            openSettings: 'Abrir configurações',
            aspectRatio: 'Proporção',
            outputCount: 'Quantidade de saída',
            resolution: 'Resolução',
            duration: 'Duração',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Início',
        lastFrame: 'Fim',
        keyframesUpload: {
            firstFrameAlt: 'Primeiro quadro',
            lastFrameAlt: 'Último quadro',
            removeFirstFrame: 'Remover primeiro quadro',
            removeLastFrame: 'Remover último quadro',
        },
        toolOptions: {
            mode: 'Modo',
            backgroundColor: 'Cor de fundo',
            outputFormat: 'Formato de saída',
            type: 'Tipo',
            extendDuration: 'Duração de extensão',
            backgroundDescription: 'Descrição do fundo',
            aspectRatio: 'Proporção',
            translateTo: 'Traduzir para',
        },
        toolOptionValues: {
            motionType: {
                move: 'Conduzido por movimento',
                replace: 'Troca de personagem',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animação 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Quadrinhos',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Descreva no prompt o conteúdo que você quer estender no vídeo...',
        },
        languageNames: {
            zh: 'Chinês (simplificado)',
            tw: 'Chinês (tradicional)',
            en: 'Inglês',
            ja: 'Japonês',
            ko: 'Coreano',
            es: 'Espanhol',
            fr: 'Francês',
            de: 'Alemão',
            ru: 'Russo',
            pl: 'Polonês',
            pt: 'Português',
            it: 'Italiano',
            ar: 'Árabe',
            th: 'Tailandês',
            da: 'Dinamarquês',
            no: 'Norueguês (Bokmål)',
            nl: 'Holandês',
            id: 'Indonésio',
            tr: 'Turco',
        },
        promptPlaceholder: 'Descreva o que você quer gerar',
        modePromptPlaceholders: {
            chat: 'Sobre o que você gostaria de conversar ou o que deseja fazer?',
            image: 'Descreva a imagem que você quer gerar, como tema, estilo e cena',
            video: 'Descreva o vídeo que você quer gerar, como cenas, movimento e enquadramento',
            music: 'Descreva o estilo musical, o clima ou o tema',
        },
        promptPlaceholderToday: 'O que você gostaria de gerar hoje?',
        positivePrompt: 'Prompt positivo',
        negativePrompt: 'Prompt negativo',
        negativePromptPlaceholder: 'Digite o prompt negativo',
        videoModeMulti: 'Geração com várias imagens',
        videoModeAddLastFrame: 'Adicionar último quadro',
        credits: '{count}',
        uploadingWait: 'Enviando, aguarde até terminar antes de colar.',
        noEmptySlot: 'Não há slots vazios disponíveis para colar imagens.',
        maxPasteLimit: 'Você pode enviar até {count} arquivos.',
        formatSupport: 'O modo de criação atual não é compatível com este tipo de arquivo: ',
        andOthers: ' e outros {count} arquivos',
        notSupportPaste: 'A ferramenta atual não suporta a colagem de imagens.',
        onlyOneVideo: 'Só é possível enviar 1 arquivo de vídeo.',
        videoTooLargePrompt: 'O arquivo de vídeo é muito grande, envie um vídeo de até {size}.',
        templateSlotLimit: 'Cada slot de modelo suporta apenas 1 imagem.',
        uploadingWaitDrag: 'Enviando, aguarde até terminar antes de arrastar.',
        uploadTypeCheck: 'O modo de criação atual não é compatível com este tipo de arquivo.',
        imageSizeLimitPrompt: 'O tamanho da imagem não pode exceder 100 MB.',
        imageResolutionLimitPrompt: 'A resolução da imagem é muito grande, o lado mais longo não pode exceder 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Imagem',
            videoGenerate: 'Vídeo',
            musicGenerate: 'Música',
            imageEdit: 'Edição de imagem',
            videoEdit: 'Edição de vídeo',
            imageTemplate: 'Modelos de imagem',
            videoTemplate: 'Modelos de vídeo',
            tools: 'Ferramentas',
        },
        secondaryTabs: {
            textToImage: 'Texto para imagem',
            imageToImage: 'Imagem para imagem',
            characterToImage: 'Personagem para imagem',
            textToVideo: 'Texto para vídeo',
            imageToVideo: 'Imagem para vídeo',
            keyframes: 'Primeiro/último quadro',
            characterToVideo: 'Personagem para vídeo',
            videoEdit: 'Edição de vídeo',
            voice: 'Vocal',
            pureMusic: 'Instrumental',
        },
        seedanceVideoModes: {
            allRound: 'Referência completa',
        },
        tertiaryTabs: {
            boyVoice: 'Voz masculina',
            girlVoice: 'Voz feminina',
        },
        configGroups: {
            voiceGender: 'Tipo de voz',
            tags: 'Tags',
        },
        audioGenerated: 'Áudio gerado',
        successAudioLinkAdded: 'Link de áudio adicionado',
        audio: 'Áudio',
        audioLink: 'Link de áudio',
        uploadAudio: 'Carregar áudio',
        addAudio: 'Adicionar áudio',
        musicPrompt: {
            removeTag: 'Remover tag',
            creativeThemeTitle: 'Tema criativo',
            creativeThemePlaceholder:
                'Descreva o estilo, o humor ou o tema da música',
            lyricsTitle: 'Digite a letra',
            lyricsPlaceholder: 'Digite a letra...',
        },
        uploadLabels: {
            video: 'Vídeo',
            image: 'Imagem',
            audio: 'Áudio',
            baseImage: 'Imagem base',
            face: 'Rosto',
        },
        seedanceAlmighty: {
            panelTitle: 'Conteudo de referencia',
            emptyTitle: 'Enviar referencias',
            dragMaterialsHere: 'Arraste os materiais para cá',
            promptPlaceholder: "Envie 1-12 recursos de referencia. Digite um texto e use {'@'}recursos para combina-los livremente. Exemplo: {'@'}Imagem1 imita {'@'}Video1 com {'@'}Audio1.",
            promptPlaceholderDance25: "Envie recursos de referencia. Digite um texto e use {'@'}recursos para combina-los livremente. Exemplo: {'@'}Imagem1 imita {'@'}Video1 com {'@'}Audio1.",
            promptMaxLength: 'O prompt deve ter no máximo {count} caracteres.',
            imageMaxCount: 'Você pode enviar até {count} imagens de referência.',
            videoDurationRange: 'Este vídeo de referência dura {current}. Envie um vídeo entre {min} e {max} segundos.',
            videoMaxCount: 'Você pode enviar até {count} vídeos de referência.',
            videoTotalDuration: 'A duração total dos vídeos após o envio seria {current}, excedendo o limite de {max} segundos.',
            audioDurationRange: 'Este áudio de referência dura {current}. Envie um áudio entre {min} e {max} segundos.',
            audioMaxCount: 'Você pode enviar até {count} áudios de referência.',
            audioTotalDuration: 'A duração total dos áudios após o envio seria {current}, excedendo o limite de {max} segundos.',
            mediaTotalDuration: 'A duração total dos vídeos e áudios de referência após o envio seria {current}, excedendo o limite de {max} segundos.',
            audioNeedsVisualReference: 'O áudio não pode ser usado sozinho. Mantenha pelo menos uma imagem ou um vídeo de referência.',
            referenceRequired: 'Envie pelo menos uma imagem ou um vídeo de referência.',
            uploadHints: {
                image: 'Suporta 1-9 imagens, ate 3 videos e ate 3 audios (cada um com 2-15 s; os totais de video e audio sao calculados separadamente, cada um <= 15 s)',
                dance25: 'Suporta ate {imageCount} imagens, {videoCount} videos e {audioCount} audios (cada video/audio com {minDuration}-{maxDuration} s; os totais de video e audio sao calculados separadamente, cada um <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Remover vídeo',
            removeImage: 'Remover imagem',
            removeAudio: 'Remover áudio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitação de movimento de vídeo por IA',
            'video-face-swap': 'Troca de rosto em vídeo por IA',
            'video-to-anime': 'Conversor de vídeo para anime por IA',
            'video-subtitle-translate': 'Tradução de legendas por IA',
            'video-upscaler': 'Aprimoramento de vídeo por IA',
            'video-background-remover': 'Remoção de fundo de vídeo por IA',
            'video-watermark-remover': 'Removedor de marca d’água por IA',
            'remove-video-subtitles': 'Remoção de legendas por IA',
            'video-extender': 'Extensor de vídeo por IA',
            'image-background-changer': 'Trocador de fundo de imagem por IA',
            'image-resizer': 'Redimensionador de imagem por IA',
            'image-text-translate': 'Tradução de texto em imagem por IA',
            'image-upscaler': 'Aprimoramento de qualidade de imagem por IA',
            'photo-face-swap': 'Substituição de rosto',
            'remove-text-image': 'Remoção de texto de imagem por IA',
            'ai-image-extender': 'Extensor de imagem por IA',
            'photo-restoration': 'Restauração de fotos antigas',
            'ai-image-background-remover': 'Removedor de fundo de imagem por IA',
            'video-lip-sync': 'Sincronização labial de vídeo por IA',
        },
        // Meus Projetos
        myProject: 'Meus Projetos',
        noProject: 'Sem projetos',
        newProject: 'Novo Projeto',
        // Ações ao passar sobre o histórico
        addToInput: 'Adicionar à criação',
        reAdd: 'Adicionar novamente',
        imageEdit: 'Editar imagem',
        videoEdit: 'Editar vídeo',
        videoToolCannotUploadImage: 'As ferramentas de edição de vídeo só podem carregar vídeos, não imagens',
        videoEditOnlySupportVideo: 'A edição de vídeo só suporta o carregamento de vídeos',
        videoAddedToTool: 'Vídeo adicionado à ferramenta',
        switchedToImageMode: 'Mudado para o modo imagem para imagem',
        switchedToVideoMode: 'Mudado para o modo de edição de vídeo',
        reEdit: 'Reeditar',
        musicCannotReEdit: 'A criação musical não pode ser reeditada',
    },
    it: {
        importLink: 'Importa link',
        videoPreview: 'Anteprima video',
        modeSelect: 'Selezione modalità',
        reselect: 'Seleziona di nuovo',
        select: 'Seleziona',
        selectModel: 'Seleziona modello',
        openQuickSwitches: 'Apri interruttori rapidi',
        quickSettings: {
            openSettings: 'Apri impostazioni',
            aspectRatio: 'Rapporto',
            outputCount: 'Numero di output',
            resolution: 'Risoluzione',
            duration: 'Durata',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Inizio',
        lastFrame: 'Fine',
        keyframesUpload: {
            firstFrameAlt: 'Primo fotogramma',
            lastFrameAlt: 'Ultimo fotogramma',
            removeFirstFrame: 'Rimuovi primo fotogramma',
            removeLastFrame: 'Rimuovi ultimo fotogramma',
        },
        toolOptions: {
            mode: 'Modalità',
            backgroundColor: 'Colore di sfondo',
            outputFormat: 'Formato di output',
            type: 'Tipo',
            extendDuration: 'Durata estensione',
            backgroundDescription: 'Descrizione dello sfondo',
            aspectRatio: 'Rapporto',
            translateTo: 'Traduci in',
        },
        toolOptionValues: {
            motionType: {
                move: 'Guidato dal movimento',
                replace: 'Sostituzione personaggio',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animazione 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Fumetto',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Descrivi nel prompt cosa vuoi estendere nel video...',
        },
        languageNames: {
            zh: 'Cinese (semplificato)',
            tw: 'Cinese (tradizionale)',
            en: 'Inglese',
            ja: 'Giapponese',
            ko: 'Coreano',
            es: 'Spagnolo',
            fr: 'Francese',
            de: 'Tedesco',
            ru: 'Russo',
            pl: 'Polacco',
            pt: 'Portoghese',
            it: 'Italiano',
            ar: 'Arabo',
            th: 'Thailandese',
            da: 'Danese',
            no: 'Norvegese (Bokmål)',
            nl: 'Olandese',
            id: 'Indonesiano',
            tr: 'Turco',
        },
        promptPlaceholder: 'Descrivi cosa vuoi generare',
        modePromptPlaceholders: {
            chat: 'Di cosa vuoi parlare o cosa vuoi fare?',
            image: 'Descrivi l\'immagine che vuoi generare, come soggetto, stile e scena',
            video: 'Descrivi il video che vuoi generare, come inquadrature, movimento e scena',
            music: 'Descrivi lo stile musicale, l’atmosfera o il tema',
        },
        promptPlaceholderToday: 'Cosa vorresti generare oggi?',
        positivePrompt: 'Prompt positivo',
        negativePrompt: 'Prompt negativo',
        negativePromptPlaceholder: 'Inserisci il prompt negativo',
        videoModeMulti: 'Generazione multi-immagine',
        videoModeAddLastFrame: 'Aggiungi ultimo fotogramma',
        credits: '{count}',
        uploadingWait: 'Caricamento in corso, attendere il completamento prima di incollare.',
        noEmptySlot: 'Non ci sono slot vuoti disponibili per incollare immagini.',
        maxPasteLimit: 'Puoi caricare fino a {count} file.',
        formatSupport: 'La modalità di creazione corrente non supporta questo tipo di file: ',
        andOthers: ' e altri {count} file',
        notSupportPaste: 'Lo strumento corrente non supporta l\'incollatura di immagini.',
        onlyOneVideo: 'È possibile caricare solo 1 file video.',
        videoTooLargePrompt: 'Il file video è troppo grande, carica un video entro {size}.',
        templateSlotLimit: 'Ogni slot del modello supporta solo 1 immagine.',
        uploadingWaitDrag: 'Caricamento in corso, attendere il completamento prima di trascinare.',
        uploadTypeCheck: 'La modalità di creazione corrente non supporta questo tipo di file.',
        imageSizeLimitPrompt: 'La dimensione dell\'immagine non può superare i 100 MB.',
        imageResolutionLimitPrompt: 'La risoluzione dell\'immagine è troppo grande, il lato più lungo non può superare i 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Immagine',
            videoGenerate: 'Video',
            musicGenerate: 'Musica',
            imageEdit: 'Modifica immagine',
            videoEdit: 'Modifica video',
            imageTemplate: 'Modelli immagine',
            videoTemplate: 'Modelli video',
            tools: 'Strumenti',
        },
        secondaryTabs: {
            textToImage: 'Testo in immagine',
            imageToImage: 'Immagine in immagine',
            characterToImage: 'Personaggio in immagine',
            textToVideo: 'Testo in video',
            imageToVideo: 'Immagine in video',
            keyframes: 'Primo/ultimo fotogramma',
            characterToVideo: 'Personaggio in video',
            videoEdit: 'Modifica video',
            voice: 'Voce',
            pureMusic: 'Musica strumentale',
        },
        seedanceVideoModes: {
            allRound: 'Riferimento completo',
        },
        tertiaryTabs: {
            boyVoice: 'Voce maschile',
            girlVoice: 'Voce femminile',
        },
        configGroups: {
            voiceGender: 'Tipo di voce',
            tags: 'Tag',
        },
        audioGenerated: 'Audio generato',
        successAudioLinkAdded: 'Link audio aggiunto',
        audio: 'Audio',
        audioLink: 'Link audio',
        uploadAudio: 'Carica audio',
        addAudio: 'Aggiungi audio',
        musicPrompt: {
            removeTag: 'Rimuovi tag',
            creativeThemeTitle: 'Tema creativo',
            creativeThemePlaceholder:
                'Descrivi lo stile, l’atmosfera o il tema della musica',
            lyricsTitle: 'Inserisci il testo',
            lyricsPlaceholder: 'Inserisci il testo...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Immagine',
            audio: 'Audio',
            baseImage: 'Immagine di base',
            face: 'Volto',
        },
        seedanceAlmighty: {
            panelTitle: 'Contenuto di riferimento',
            emptyTitle: 'Carica riferimenti',
            dragMaterialsHere: 'Trascina qui i materiali',
            promptPlaceholder: "Carica 1-12 risorse di riferimento. Inserisci testo e aggiungi {'@'}risorse per combinarle liberamente. Esempio: {'@'}Immagine1 imita {'@'}Video1 con {'@'}Audio1.",
            promptPlaceholderDance25: "Carica risorse di riferimento. Inserisci testo e aggiungi {'@'}risorse per combinarle liberamente. Esempio: {'@'}Immagine1 imita {'@'}Video1 con {'@'}Audio1.",
            promptMaxLength: 'Il prompt non può superare {count} caratteri.',
            imageMaxCount: 'Puoi caricare fino a {count} immagini di riferimento.',
            videoDurationRange: 'Questo video di riferimento dura {current}. Carica un video tra {min} e {max} secondi.',
            videoMaxCount: 'Puoi caricare fino a {count} video di riferimento.',
            videoTotalDuration: 'La durata totale dei video dopo il caricamento sarebbe {current}, superando il limite di {max} secondi.',
            audioDurationRange: 'Questo audio di riferimento dura {current}. Carica un audio tra {min} e {max} secondi.',
            audioMaxCount: 'Puoi caricare fino a {count} audio di riferimento.',
            audioTotalDuration: 'La durata totale degli audio dopo il caricamento sarebbe {current}, superando il limite di {max} secondi.',
            mediaTotalDuration: 'La durata totale dei video e degli audio di riferimento dopo il caricamento sarebbe {current}, superando il limite di {max} secondi.',
            audioNeedsVisualReference: 'L audio non può essere usato da solo. Mantieni almeno una immagine o un video di riferimento.',
            referenceRequired: 'Carica almeno una immagine o un video di riferimento.',
            uploadHints: {
                image: 'Supporta 1-9 immagini, fino a 3 video e fino a 3 audio (ognuno di 2-15 s; le durate totali di video e audio sono calcolate separatamente, ciascuna <= 15 s)',
                dance25: 'Supporta fino a {imageCount} immagini, {videoCount} video e {audioCount} audio (ogni video/audio {minDuration}-{maxDuration} s; le durate totali di video e audio sono calcolate separatamente, ciascuna <= {totalDuration} s)',
            },
        },
        uploadStrip: {
            removeVideo: 'Rimuovi video',
            removeImage: 'Rimuovi immagine',
            removeAudio: 'Rimuovi audio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitazione del movimento video con IA',
            'video-face-swap': 'Scambio del volto nei video con IA',
            'video-to-anime': 'Convertitore video in anime con IA',
            'video-subtitle-translate': 'Traduzione dei sottotitoli con IA',
            'video-upscaler': 'Miglioramento video con IA',
            'video-background-remover': 'Rimozione dello sfondo video con IA',
            'video-watermark-remover': 'Rimozione filigrana con IA',
            'remove-video-subtitles': 'Rimozione sottotitoli con IA',
            'video-extender': 'Estensore video con IA',
            'image-background-changer': 'Cambia sfondo immagine con IA',
            'image-resizer': 'Ridimensionatore immagini con IA',
            'image-text-translate': 'Traduzione del testo nelle immagini con IA',
            'image-upscaler': 'Miglioramento qualità immagine con IA',
            'photo-face-swap': 'Sostituzione del volto',
            'remove-text-image': 'Rimozione testo dalle immagini con IA',
            'ai-image-extender': 'Estensione immagine con IA',
            'photo-restoration': 'Restauro foto d’epoca',
            'ai-image-background-remover': 'Rimozione sfondo immagine con IA',
            'video-lip-sync': 'Lip sync video con IA',
        },
        // I miei progetti
        myProject: 'I miei progetti',
        noProject: 'Nessun progetto',
        newProject: 'Nuovo Progetto',
        // Azioni hover cronologia
        addToInput: 'Aggiungi alla creazione',
        reAdd: 'Aggiungi di nuovo',
        imageEdit: 'Modifica immagine',
        videoEdit: 'Modifica video',
        videoToolCannotUploadImage: 'Gli strumenti di editing video possono caricare solo video, non immagini',
        videoEditOnlySupportVideo: 'L\'editing video supporta solo il caricamento di video',
        videoAddedToTool: 'Video aggiunto allo strumento',
        switchedToImageMode: 'Passato alla modalità immagine a immagine',
        switchedToVideoMode: 'Passato alla modalità di modifica video',
        reEdit: 'Rimodifica',
        musicCannotReEdit: 'La creazione musicale non può essere rimodificata',
    },
    ar: {
        importLink: 'استيراد الرابط',
        videoPreview: 'معاينة الفيديو',
        modeSelect: 'اختيار الوضع',
        reselect: 'إعادة الاختيار',
        select: 'اختيار',
        selectModel: 'اختيار النموذج',
        openQuickSwitches: 'فتح المفاتيح السريعة',
        quickSettings: {
            openSettings: 'فتح الإعدادات',
            aspectRatio: 'نسبة الأبعاد',
            outputCount: 'عدد المخرجات',
            resolution: 'الدقة',
            duration: 'المدة',
            secondsLabel: '{value}ث',
        },
        avatar: 'الصورة',
        firstFrame: 'بداية',
        lastFrame: 'نهاية',
        keyframesUpload: {
            firstFrameAlt: 'الإطار الأول',
            lastFrameAlt: 'الإطار الأخير',
            removeFirstFrame: 'إزالة الإطار الأول',
            removeLastFrame: 'إزالة الإطار الأخير',
        },
        toolOptions: {
            mode: 'الوضع',
            backgroundColor: 'لون الخلفية',
            outputFormat: 'صيغة الإخراج',
            type: 'النوع',
            extendDuration: 'مدة التمديد',
            backgroundDescription: 'وصف الخلفية',
            aspectRatio: 'نسبة الأبعاد',
            translateTo: 'الترجمة إلى',
        },
        toolOptionValues: {
            motionType: {
                move: 'مدفوع بالحركة',
                replace: 'استبدال الشخصية',
            },
            videoExtenderStyle: {
                anime: 'أنمي',
                '3dAnimation': 'رسوم متحركة ثلاثية الأبعاد',
                cyberpunk: 'سايبربانك',
                comic: 'قصص مصوّرة',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'أدخل موجهًا يصف ما تريد تمديده في الفيديو...',
        },
        languageNames: {
            zh: 'الصينية (المبسطة)',
            tw: 'الصينية (التقليدية)',
            en: 'الإنجليزية',
            ja: 'اليابانية',
            ko: 'الكورية',
            es: 'الإسبانية',
            fr: 'الفرنسية',
            de: 'الألمانية',
            ru: 'الروسية',
            pl: 'البولندية',
            pt: 'البرتغالية',
            it: 'الإيطالية',
            ar: 'العربية',
            th: 'التايلاندية',
            da: 'الدنماركية',
            no: 'النرويجية (بوكمول)',
            nl: 'الهولندية',
            id: 'الإندونيسية',
            tr: 'التركية',
        },
        promptPlaceholder: 'صف ما تريد إنشاءه',
        modePromptPlaceholders: {
            chat: 'عم تريد التحدث أو ما الذي تريد إنجازه؟',
            image: 'صف الصورة التي تريد إنشاءها، مثل الموضوع والأسلوب والمشهد',
            video: 'صف الفيديو الذي تريد إنشاءه، مثل اللقطات والحركة والمشهد',
            music: 'صف النمط الموسيقي أو الأجواء أو الموضوع',
        },
        promptPlaceholderToday: 'ماذا تريد أن تُنشئ اليوم؟',
        positivePrompt: 'موجه إيجابي',
        negativePrompt: 'موجه سلبي',
        negativePromptPlaceholder: 'أدخل الموجه السلبي',
        videoModeMulti: 'إنشاء متعدد الصور',
        videoModeAddLastFrame: 'إضافة الإطار الأخير',
        credits: '{count}',
        uploadingWait: 'جاري الرفع، يرجى الانتظار حتى الانتهاء قبل اللصق.',
        noEmptySlot: 'لا توجد فتحات فارغة متاحة للصق الصور.',
        maxPasteLimit: 'يمكنك رفع ما يصل إلى {count} ملفًا.',
        formatSupport: 'وضع الإنشاء الحالي لا يدعم هذا النوع من الملفات: ',
        andOthers: ' و {count} ملفات أخرى',
        notSupportPaste: 'الأداة الحالية لا تدعم لصق الصور.',
        onlyOneVideo: 'يمكن رفع ملف فيديو واحد فقط.',
        videoTooLargePrompt: 'ملف الفيديو كبير جداً، يرجى رفع فيديو في حدود {size}.',
        templateSlotLimit: 'كل فتحة قالب تدعم صورة واحدة فقط.',
        uploadingWaitDrag: 'جاري الرفع، يرجى الانتظار حتى الانتهاء قبل السحب.',
        uploadTypeCheck: 'وضع الإنشاء الحالي لا يدعم هذا النوع من الملفات.',
        imageSizeLimitPrompt: 'لا يمكن أن يتجاوز حجم الصورة 10 ميجابايت.',
        imageResolutionLimitPrompt: 'دقة الصورة كبيرة جداً، لا يمكن أن يتجاوز الجانب الأطول 4096 بكسل.',
        primaryTabs: {
            chat: 'الدردشة',
            imageGenerate: 'صورة',
            videoGenerate: 'فيديو',
            musicGenerate: 'موسيقى',
            imageEdit: 'تحرير الصور',
            videoEdit: 'تحرير الفيديو',
            imageTemplate: 'قوالب الصور',
            videoTemplate: 'قوالب الفيديو',
            tools: 'أدوات',
        },
        secondaryTabs: {
            textToImage: 'نص إلى صورة',
            imageToImage: 'صورة إلى صورة',
            characterToImage: 'شخصية إلى صورة',
            textToVideo: 'نص إلى فيديو',
            imageToVideo: 'صورة إلى فيديو',
            keyframes: 'الإطار الأول/الأخير',
            characterToVideo: 'شخصية إلى فيديو',
            videoEdit: 'تحرير الفيديو',
            voice: 'غناء',
            pureMusic: 'موسيقى آلية',
        },
        seedanceVideoModes: {
            allRound: 'مرجع شامل',
        },
        tertiaryTabs: {
            boyVoice: 'صوت ذكر',
            girlVoice: 'صوت أنثى',
        },
        configGroups: {
            voiceGender: 'نوع الصوت',
            tags: 'علامات',
        },
        audioGenerated: 'تم إنشاء الصوت',
        successAudioLinkAdded: 'تمت إضافة رابط الصوت',
        audio: 'صوت',
        audioLink: 'رابط الصوت',
        uploadAudio: 'تحميل الصوت',
        addAudio: 'إضافة صوت',
        musicPrompt: {
            removeTag: 'إزالة الوسم',
            creativeThemeTitle: 'موضوع إبداعي',
            creativeThemePlaceholder: 'صف أسلوب الموسيقى أو المزاج أو الموضوع',
            lyricsTitle: 'أدخل الكلمات',
            lyricsPlaceholder: 'أدخل الكلمات...',
        },
        uploadLabels: {
            video: 'فيديو',
            image: 'صورة',
            audio: 'صوت',
            baseImage: 'الصورة الأساسية',
            face: 'وجه',
        },
        seedanceAlmighty: {
            panelTitle: 'المحتوى المرجعي',
            emptyTitle: 'رفع المراجع',
            dragMaterialsHere: 'اسحب المواد إلى هنا',
            promptPlaceholder: "ارفع 1-12 عنصراً مرجعياً. أدخل نصاً وأضف {'@'}للعناصر لدمجها بحرية. مثال: {'@'}صورة1 تقلد {'@'}فيديو1 باستخدام {'@'}صوت1.",
            promptPlaceholderDance25: "ارفع العناصر المرجعية. أدخل نصاً وأضف {'@'}للعناصر لدمجها بحرية. مثال: {'@'}صورة1 تقلد {'@'}فيديو1 باستخدام {'@'}صوت1.",
            promptMaxLength: 'يجب ألا يتجاوز الوصف {count} حرفا.',
            imageMaxCount: 'يمكنك رفع ما يصل إلى {count} صورة مرجعية.',
            videoDurationRange: 'مدة هذا الفيديو المرجعي هي {current}. يُرجى رفع فيديو مدته بين {min} و {max} ثانية.',
            videoMaxCount: 'يمكنك رفع ما يصل إلى {count} مقاطع فيديو مرجعية.',
            videoTotalDuration: 'سيصبح إجمالي مدة الفيديوهات بعد الرفع {current}، وهذا يتجاوز الحد الأقصى {max} ثانية.',
            audioDurationRange: 'مدة هذا المقطع الصوتي المرجعي هي {current}. يُرجى رفع مقطع صوتي مدته بين {min} و {max} ثانية.',
            audioMaxCount: 'يمكنك رفع ما يصل إلى {count} مقاطع صوتية مرجعية.',
            audioTotalDuration: 'سيصبح إجمالي مدة المقاطع الصوتية بعد الرفع {current}، وهذا يتجاوز الحد الأقصى {max} ثانية.',
            mediaTotalDuration: 'سيصبح إجمالي مدة الفيديوهات والمقاطع الصوتية المرجعية بعد الرفع {current}، وهذا يتجاوز الحد الأقصى {max} ثانية.',
            audioNeedsVisualReference: 'لا يمكن استخدام الصوت وحده. احتفظ بصورة مرجعية واحدة أو فيديو مرجعي واحد على الأقل.',
            referenceRequired: 'ارفع صورة مرجعية واحدة أو فيديو مرجعي واحد على الأقل.',
            uploadHints: {
                image: 'يدعم رفع 1-9 صور، وحتى 3 فيديوهات، وحتى 3 ملفات صوتية (مدة كل ملف 2-15 ثانية، ويُحسب إجمالي الفيديو والصوت بشكل منفصل، لكل منهما <= 15 ثانية)',
                dance25: 'يدعم حتى {imageCount} صورة و{videoCount} فيديو و{audioCount} ملف صوت (مدة كل فيديو/صوت {minDuration}-{maxDuration} ثانية، ويُحسب إجمالي الفيديو والصوت بشكل منفصل، لكل منهما <= {totalDuration} ثانية)',
            },
        },
        uploadStrip: {
            removeVideo: 'إزالة الفيديو',
            removeImage: 'إزالة الصورة',
            removeAudio: 'إزالة الصوت',
        },
        toolTitles: {
            'video-motion-imitation': 'محاكاة حركة الفيديو بالذكاء الاصطناعي',
            'video-face-swap': 'تبديل الوجه في الفيديو بالذكاء الاصطناعي',
            'video-to-anime': 'محول الفيديو إلى أنمي بالذكاء الاصطناعي',
            'video-subtitle-translate': 'ترجمة الترجمة النصية بالذكاء الاصطناعي',
            'video-upscaler': 'تحسين الفيديو بالذكاء الاصطناعي',
            'video-background-remover': 'إزالة خلفية الفيديو بالذكاء الاصطناعي',
            'video-watermark-remover': 'إزالة العلامة المائية بالذكاء الاصطناعي',
            'remove-video-subtitles': 'إزالة الترجمة النصية بالذكاء الاصطناعي',
            'video-extender': 'مُمدِّد الفيديو بالذكاء الاصطناعي',
            'image-background-changer': 'مبدّل خلفية الصورة بالذكاء الاصطناعي',
            'image-resizer': 'مُغيّر حجم الصورة بالذكاء الاصطناعي',
            'image-text-translate': 'ترجمة نص الصورة بالذكاء الاصطناعي',
            'image-upscaler': 'تحسين جودة الصورة بالذكاء الاصطناعي',
            'photo-face-swap': 'استبدال الوجه',
            'remove-text-image': 'إزالة نص الصورة بالذكاء الاصطناعي',
            'ai-image-extender': 'توسيع الصورة بالذكاء الاصطناعي',
            'photo-restoration': 'ترميم الصور القديمة',
            'ai-image-background-remover': 'إزالة خلفية الصورة بالذكاء الاصطناعي',
            'video-lip-sync': 'مزامنة الشفاه للفيديو بالذكاء الاصطناعي',
        },
        // مشاريعي
        myProject: 'مشاريعي',
        noProject: 'لا توجد مشاريع',
        newProject: 'مشروع جديد',
        // إجراءات التمرير فوق السجل
        addToInput: 'إضافة إلى الإنشاء',
        reAdd: 'إعادة الإضافة',
        imageEdit: 'تحرير الصورة',
        videoEdit: 'تحرير الفيديو',
        videoToolCannotUploadImage: 'أدوات تحرير الفيديو يمكنها تحميل مقاطع الفيديو فقط وليس الصور',
        videoEditOnlySupportVideo: 'تحرير الفيديو يدعم تحميل الفيديوهات فقط',
        videoAddedToTool: 'تمت إضافة الفيديو إلى الأداة',
        switchedToImageMode: 'تم التبديل إلى وضع صورة إلى صورة',
        switchedToVideoMode: 'تم التبديل إلى وضع تحرير الفيديو',
        reEdit: 'إعادة التحرير',
        musicCannotReEdit: 'لا يمكن إعادة تحرير الإبداع الموسيقي',
    },
    th: {
        importLink: 'นำเข้าลิงก์',
        videoPreview: 'ตัวอย่างวิดีโอ',
        modeSelect: 'เลือกโหมด',
        reselect: 'เลือกใหม่',
        select: 'เลือก',
        selectModel: 'เลือกโมเดล',
        openQuickSwitches: 'เปิดสวิตช์ด่วน',
        quickSettings: {
            openSettings: 'เปิดการตั้งค่า',
            aspectRatio: 'อัตราส่วนภาพ',
            outputCount: 'จำนวนผลลัพธ์',
            resolution: 'ความละเอียด',
            duration: 'ระยะเวลา',
            secondsLabel: '{value}วินาที',
        },
        avatar: 'อวาตาร์',
        firstFrame: 'เริ่ม',
        lastFrame: 'จบ',
        keyframesUpload: {
            firstFrameAlt: 'เฟรมแรก',
            lastFrameAlt: 'เฟรมสุดท้าย',
            removeFirstFrame: 'ลบเฟรมแรก',
            removeLastFrame: 'ลบเฟรมสุดท้าย',
        },
        toolOptions: {
            mode: 'โหมด',
            backgroundColor: 'สีพื้นหลัง',
            outputFormat: 'รูปแบบเอาต์พุต',
            type: 'ประเภท',
            extendDuration: 'ระยะเวลาการขยาย',
            backgroundDescription: 'คำอธิบายพื้นหลัง',
            aspectRatio: 'อัตราส่วนภาพ',
            translateTo: 'แปลเป็น',
        },
        toolOptionValues: {
            motionType: {
                move: 'ขับเคลื่อนด้วยการเคลื่อนไหว',
                replace: 'สลับตัวละคร',
            },
            videoExtenderStyle: {
                anime: 'อนิเมะ',
                '3dAnimation': 'แอนิเมชัน 3 มิติ',
                cyberpunk: 'ไซเบอร์พังก์',
                comic: 'การ์ตูน',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'โปรดใส่พรอมป์เพื่ออธิบายเนื้อหาที่ต้องการขยายในวิดีโอ...',
        },
        languageNames: {
            zh: 'จีน (ตัวย่อ)',
            tw: 'จีน (ตัวเต็ม)',
            en: 'อังกฤษ',
            ja: 'ญี่ปุ่น',
            ko: 'เกาหลี',
            es: 'สเปน',
            fr: 'ฝรั่งเศส',
            de: 'เยอรมัน',
            ru: 'รัสเซีย',
            pl: 'โปแลนด์',
            pt: 'โปรตุเกส',
            it: 'อิตาลี',
            ar: 'อาหรับ',
            th: 'ไทย',
            da: 'เดนมาร์ก',
            no: 'นอร์เวย์ (บ็อกมอล)',
            nl: 'ดัตช์',
            id: 'อินโดนีเซีย',
            tr: 'ตุรกี',
        },
        promptPlaceholder: 'อธิบายสิ่งที่คุณต้องการสร้าง',
        modePromptPlaceholders: {
            chat: 'คุณอยากคุยเรื่องอะไร หรืออยากให้ช่วยทำอะไร',
            image: 'อธิบายภาพที่คุณต้องการสร้าง เช่น ตัวแบบ สไตล์ และฉาก',
            video: 'อธิบายวิดีโอที่คุณต้องการสร้าง เช่น ช็อต การเคลื่อนไหว และฉาก',
            music: 'อธิบายสไตล์เพลง อารมณ์ หรือธีม',
        },
        promptPlaceholderToday: 'วันนี้คุณอยากสร้างอะไร',
        positivePrompt: 'พรอมป์เชิงบวก',
        negativePrompt: 'พรอมป์เชิงลบ',
        negativePromptPlaceholder: 'ป้อนพรอมป์เชิงลบ',
        videoModeMulti: 'สร้างจากหลายภาพ',
        videoModeAddLastFrame: 'เพิ่มเฟรมสุดท้าย',
        credits: '{count}',
        uploadingWait: 'กำลังอัปโหลด โปรดรอจนกว่าจะเสร็จสิ้นก่อนวาง',
        noEmptySlot: 'ไม่มีช่องว่างสำหรับวางรูปภาพ',
        maxPasteLimit: 'อัปโหลดได้สูงสุด {count} ไฟล์',
        formatSupport: 'โหมดการสร้างปัจจุบันไม่รองรับประเภทไฟล์นี้: ',
        andOthers: ' และไฟล์อื่นๆ อีก {count} ไฟล์',
        notSupportPaste: 'เครื่องมือปัจจุบันไม่รองรับการวางรูปภาพ',
        onlyOneVideo: 'สามารถอัปโหลดไฟล์วิดีโอได้เพียง 1 ไฟล์เท่านั้น',
        videoTooLargePrompt: 'ไฟล์วิดีโอใหญ่เกินไป โปรดอัปโหลดวิดีโอภายใน {size}',
        templateSlotLimit: 'แต่ละช่องเทมเพลตรองรับรูปภาพเพียง 1 รูปเท่านั้น',
        uploadingWaitDrag: 'กำลังอัปโหลด โปรดรอจนกว่าจะเสร็จสิ้นก่อนลาก',
        uploadTypeCheck: 'โหมดการสร้างปัจจุบันไม่รองรับประเภทไฟล์นี้',
        imageSizeLimitPrompt: 'ขนาดรูปภาพต้องไม่เกิน 100MB',
        imageResolutionLimitPrompt: 'ความละเอียดของรูปภาพใหญ่เกินไป ด้านที่ยาวที่สุดต้องไม่เกิน 4096px',
        primaryTabs: {
            chat: 'แชท',
            imageGenerate: 'รูปภาพ',
            videoGenerate: 'วิดีโอ',
            musicGenerate: 'เพลง',
            imageEdit: 'แก้ไขภาพ',
            videoEdit: 'แก้ไขวิดีโอ',
            imageTemplate: 'เทมเพลตรูปภาพ',
            videoTemplate: 'เทมเพลตวิดีโอ',
            tools: 'เครื่องมือ',
        },
        secondaryTabs: {
            textToImage: 'ข้อความเป็นภาพ',
            imageToImage: 'ภาพเป็นภาพ',
            characterToImage: 'ตัวละครเป็นภาพ',
            textToVideo: 'ข้อความเป็นวิดีโอ',
            imageToVideo: 'ภาพเป็นวิดีโอ',
            keyframes: 'เฟรมแรก/เฟรมสุดท้าย',
            characterToVideo: 'ตัวละครเป็นวิดีโอ',
            videoEdit: 'แก้ไขวิดีโอ',
            voice: 'เสียงร้อง',
            pureMusic: 'ดนตรีล้วน',
        },
        seedanceVideoModes: {
            allRound: 'อ้างอิงอเนกประสงค์',
        },
        tertiaryTabs: {
            boyVoice: 'เสียงผู้ชาย',
            girlVoice: 'เสียงผู้หญิง',
        },
        configGroups: {
            voiceGender: 'ประเภทเสียง',
            tags: 'แท็ก',
        },
        audioGenerated: 'สร้างเสียงแล้ว',
        successAudioLinkAdded: 'เพิ่มลิงก์เสียงแล้ว',
        audio: 'เสียง',
        audioLink: 'ลิงก์เสียง',
        uploadAudio: 'อัปโหลดเสียง',
        addAudio: 'เพิ่มเสียง',
        musicPrompt: {
            removeTag: 'ลบแท็ก',
            creativeThemeTitle: 'ธีมสร้างสรรค์',
            creativeThemePlaceholder: 'อธิบายสไตล์ อารมณ์ หรือธีมของเพลง',
            lyricsTitle: 'ป้อนเนื้อเพลง',
            lyricsPlaceholder: 'ป้อนเนื้อเพลง...',
        },
        uploadLabels: {
            video: 'วิดีโอ',
            image: 'รูปภาพ',
            audio: 'เสียง',
            baseImage: 'รูปภาพต้นฉบับ',
            face: 'ใบหน้า',
        },
        seedanceAlmighty: {
            panelTitle: 'เนื้อหาอ้างอิง',
            emptyTitle: 'อัปโหลดข้อมูลอ้างอิง',
            dragMaterialsHere: 'ลากสื่อมาที่นี่',
            promptPlaceholder: "อัปโหลดสื่ออ้างอิง 1-12 รายการ พิมพ์ข้อความและใส่ {'@'}สื่อเพื่อผสานได้อย่างอิสระ ตัวอย่าง: ให้ {'@'}รูปภาพ1 เลียนแบบ {'@'}วิดีโอ1 โดยใช้ {'@'}เสียง1",
            promptPlaceholderDance25: "อัปโหลดสื่ออ้างอิง พิมพ์ข้อความและใส่ {'@'}สื่อเพื่อผสานได้อย่างอิสระ ตัวอย่าง: ให้ {'@'}รูปภาพ1 เลียนแบบ {'@'}วิดีโอ1 โดยใช้ {'@'}เสียง1",
            promptMaxLength: 'พรอมต์ต้องมีความยาวไม่เกิน {count} อักขระ',
            imageMaxCount: 'อัปโหลดรูปภาพอ้างอิงได้สูงสุด {count} รูป',
            videoDurationRange: 'วิดีโอนี้มีความยาว {current} โปรดอัปโหลดวิดีโอที่มีความยาวระหว่าง {min} ถึง {max} วินาที',
            videoMaxCount: 'อัปโหลดวิดีโออ้างอิงได้สูงสุด {count} รายการ',
            videoTotalDuration: 'ความยาวรวมของวิดีโอหลังอัปโหลดจะเป็น {current} ซึ่งเกินขีดจำกัด {max} วินาที',
            audioDurationRange: 'เสียงนี้มีความยาว {current} โปรดอัปโหลดเสียงที่มีความยาวระหว่าง {min} ถึง {max} วินาที',
            audioMaxCount: 'อัปโหลดเสียงอ้างอิงได้สูงสุด {count} รายการ',
            audioTotalDuration: 'ความยาวรวมของเสียงหลังอัปโหลดจะเป็น {current} ซึ่งเกินขีดจำกัด {max} วินาที',
            mediaTotalDuration: 'ความยาวรวมของวิดีโอและเสียงอ้างอิงหลังอัปโหลดจะเป็น {current} ซึ่งเกินขีดจำกัด {max} วินาที',
            audioNeedsVisualReference: 'ไม่สามารถใช้อ้างอิงเสียงเพียงอย่างเดียวได้ กรุณาคงรูปภาพอ้างอิงหรือวิดีโออ้างอิงอย่างน้อย 1 รายการ',
            referenceRequired: 'กรุณาอัปโหลดรูปภาพอ้างอิงหรือวิดีโออ้างอิงอย่างน้อย 1 รายการ',
            uploadHints: {
                image: 'รองรับการอัปโหลดรูปภาพ 1-9 รูป, วิดีโอสูงสุด 3 ไฟล์, และเสียงสูงสุด 3 ไฟล์ (แต่ละไฟล์ 2-15 วินาที, รวมเวลาวิดีโอและเสียงแยกกัน แต่ละประเภทไม่เกิน 15 วินาที)',
                dance25: 'รองรับรูปภาพสูงสุด {imageCount} รูป วิดีโอ {videoCount} รายการ และเสียง {audioCount} รายการ (วิดีโอ/เสียงแต่ละรายการ {minDuration}-{maxDuration} วินาที โดยรวมเวลาวิดีโอและเสียงแยกกัน แต่ละประเภทไม่เกิน {totalDuration} วินาที)',
            },
        },
        uploadStrip: {
            removeVideo: 'ลบวิดีโอ',
            removeImage: 'ลบรูปภาพ',
            removeAudio: 'ลบเสียง',
        },
        toolTitles: {
            'video-motion-imitation': 'การเลียนแบบการเคลื่อนไหววิดีโอด้วย AI',
            'video-face-swap': 'สลับใบหน้าในวิดีโอด้วย AI',
            'video-to-anime': 'ตัวแปลงวิดีโอเป็นอนิเมะด้วย AI',
            'video-subtitle-translate': 'แปลคำบรรยายด้วย AI',
            'video-upscaler': 'เพิ่มคุณภาพวิดีโอด้วย AI',
            'video-background-remover': 'ลบพื้นหลังวิดีโอด้วย AI',
            'video-watermark-remover': 'ลบลายน้ำด้วย AI',
            'remove-video-subtitles': 'ลบคำบรรยายด้วย AI',
            'video-extender': 'ตัวขยายวิดีโอด้วย AI',
            'image-background-changer': 'เปลี่ยนพื้นหลังรูปภาพด้วย AI',
            'image-resizer': 'ปรับขนาดรูปภาพด้วย AI',
            'image-text-translate': 'แปลข้อความในรูปภาพด้วย AI',
            'image-upscaler': 'เพิ่มคุณภาพรูปภาพด้วย AI',
            'photo-face-swap': 'แทนที่ใบหน้า',
            'remove-text-image': 'ลบข้อความออกจากรูปภาพด้วย AI',
            'ai-image-extender': 'ขยายรูปภาพด้วย AI',
            'photo-restoration': 'ซ่อมแซมรูปถ่ายเก่า',
            'ai-image-background-remover': 'ลบพื้นหลังรูปภาพด้วย AI',
            'video-lip-sync': 'ซิงค์ปากวิดีโอด้วย AI',
        },
        // โปรเจกต์ของฉัน
        myProject: 'โปรเจกต์ของฉัน',
        noProject: 'ไม่มีโปรเจกต์',
        newProject: 'โปรเจกต์ใหม่',
        // การดำเนินการโฮเวอร์ประวัติ
        addToInput: 'เพิ่มในการสร้าง',
        reAdd: 'เพิ่มอีกครั้ง',
        imageEdit: 'แก้ไขภาพ',
        videoEdit: 'แก้ไขวิดีโอ',
        videoToolCannotUploadImage: 'เครื่องมือแก้ไขวิดีโอสามารถอัปโหลดได้เฉพาะวิดีโอเท่านั้น ไม่สามารถอัปโหลดรูปภาพได้',
        videoEditOnlySupportVideo: 'การแก้ไขวิดีโอรองรับการอัปโหลดวิดีโอเท่านั้น',
        videoAddedToTool: 'เพิ่มวิดีโอไปยังเครื่องมือแล้ว',
        switchedToImageMode: 'เปลี่ยนเป็นโหมดภาพเป็นภาพแล้ว',
        switchedToVideoMode: 'เปลี่ยนเป็นโหมดแก้ไขวิดีโอแล้ว',
        reEdit: 'แก้ไขอีกครั้ง',
        musicCannotReEdit: 'การสร้างเพลงไม่สามารถแก้ไขอีกครั้งได้',
    },
    da: {
        importLink: 'Importer link',
        videoPreview: 'Videoforhåndsvisning',
        modeSelect: 'Vælg tilstand',
        reselect: 'Vælg igen',
        select: 'Vælg',
        selectModel: 'Vælg model',
        openQuickSwitches: 'Åbn hurtige skift',
        quickSettings: {
            openSettings: 'Åbn indstillinger',
            aspectRatio: 'Billedformat',
            outputCount: 'Antal output',
            resolution: 'Opløsning',
            duration: 'Varighed',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Start',
        lastFrame: 'Slut',
        keyframesUpload: {
            firstFrameAlt: 'Første frame',
            lastFrameAlt: 'Sidste frame',
            removeFirstFrame: 'Fjern første frame',
            removeLastFrame: 'Fjern sidste frame',
        },
        toolOptions: {
            mode: 'Tilstand',
            backgroundColor: 'Baggrundsfarve',
            outputFormat: 'Outputformat',
            type: 'Type',
            extendDuration: 'Forlængelsesvarighed',
            backgroundDescription: 'Baggrundsbeskrivelse',
            aspectRatio: 'Billedformat',
            translateTo: 'Oversæt til',
        },
        toolOptionValues: {
            motionType: {
                move: 'Bevægelsesstyret',
                replace: 'Karakterudskiftning',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D-animation',
                cyberpunk: 'Cyberpunk',
                comic: 'Tegneserie',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Indtast en prompt, der beskriver, hvad der skal forlænges i videoen...',
        },
        languageNames: {
            zh: 'Kinesisk (forenklet)',
            tw: 'Kinesisk (traditionelt)',
            en: 'Engelsk',
            ja: 'Japansk',
            ko: 'Koreansk',
            es: 'Spansk',
            fr: 'Fransk',
            de: 'Tysk',
            ru: 'Russisk',
            pl: 'Polsk',
            pt: 'Portugisisk',
            it: 'Italiensk',
            ar: 'Arabisk',
            th: 'Thai',
            da: 'Dansk',
            no: 'Norsk bokmål',
            nl: 'Hollandsk',
            id: 'Indonesisk',
            tr: 'Tyrkisk',
        },
        promptPlaceholder: 'Beskriv hvad du vil generere',
        modePromptPlaceholders: {
            chat: 'Hvad vil du gerne tale om, eller hvad vil du gerne have gjort?',
            image: 'Beskriv det billede, du vil generere, for eksempel motiv, stil og scene',
            video: 'Beskriv den video, du vil generere, for eksempel optagelser, bevægelse og scene',
            music: 'Beskriv musikstilen, stemningen eller temaet',
        },
        promptPlaceholderToday: 'Hvad vil du gerne generere i dag?',
        positivePrompt: 'Positiv prompt',
        negativePrompt: 'Negativ prompt',
        negativePromptPlaceholder: 'Indtast negativ prompt',
        videoModeMulti: 'Generering med flere billeder',
        videoModeAddLastFrame: 'Tilføj sidste frame',
        credits: '{count}',
        uploadingWait: 'Uploader, vent venligst til det er færdigt, før du indsætter.',
        noEmptySlot: 'Ingen ledige pladser til at indsætte billeder.',
        maxPasteLimit: 'Du kan uploade op til {count} filer.',
        formatSupport: 'Den aktuelle oprettelsestilstand understøtter ikke denne filtype: ',
        andOthers: ' og {count} andre filer',
        notSupportPaste: 'Det nuværende værktøj understøtter ikke indsættelse af billeder.',
        onlyOneVideo: 'Kun 1 videofil kan uploades.',
        videoTooLargePrompt: 'Videofilen er for stor, upload venligst en video inden for {size}.',
        templateSlotLimit: 'Hver skabelonplads understøtter kun 1 billede.',
        uploadingWaitDrag: 'Uploader, vent venligst til det er færdigt, før du trækker.',
        uploadTypeCheck: 'Den aktuelle oprettelsestilstand understøtter ikke denne filtype.',
        imageSizeLimitPrompt: 'Billedstørrelsen må ikke overstige 100 MB.',
        imageResolutionLimitPrompt: 'Billedopløsningen er for stor, den længste side må ikke overstige 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Billede',
            videoGenerate: 'Video',
            musicGenerate: 'Musik',
            imageEdit: 'Billedredigering',
            videoEdit: 'Videoredigering',
            imageTemplate: 'Billedskabeloner',
            videoTemplate: 'Videoskabeloner',
            tools: 'Værktøjer',
        },
        secondaryTabs: {
            textToImage: 'Tekst til billede',
            imageToImage: 'Billede til billede',
            characterToImage: 'Karakter til billede',
            textToVideo: 'Tekst til video',
            imageToVideo: 'Billede til video',
            keyframes: 'Første/sidste frame',
            characterToVideo: 'Karakter til video',
            videoEdit: 'Videoredigering',
            voice: 'Vokal',
            pureMusic: 'Instrumental musik',
        },
        seedanceVideoModes: {
            allRound: 'Alsidig reference',
        },
        tertiaryTabs: {
            boyVoice: 'Mandlig stemme',
            girlVoice: 'Kvindelig stemme',
        },
        configGroups: {
            voiceGender: 'Stemmetype',
            tags: 'Tags',
        },
        audioGenerated: 'Lyd genereret',
        successAudioLinkAdded: 'Lydlink tilføjet',
        audio: 'Lyd',
        audioLink: 'Lydlink',
        uploadAudio: 'Upload lyd',
        addAudio: 'Tilføj lyd',
        musicPrompt: {
            removeTag: 'Fjern tag',
            creativeThemeTitle: 'Kreativt tema',
            creativeThemePlaceholder: 'Beskriv musikstil, stemning eller tema',
            lyricsTitle: 'Indtast sangtekst',
            lyricsPlaceholder: 'Indtast sangtekst...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Billede',
            audio: 'Lyd',
            baseImage: 'Basisbillede',
            face: 'Ansigt',
        },
        seedanceAlmighty: {
            panelTitle: 'Referenceindhold',
            emptyTitle: 'Upload referencer',
            dragMaterialsHere: 'Traek materialer hertil',
            promptPlaceholder: "Upload 1-12 referencematerialer. Indtast tekst og brug {'@'}materialer til at kombinere dem frit. Eksempel: {'@'}Billede1 efterligner {'@'}Video1 med {'@'}Lyd1.",
            promptPlaceholderDance25: "Upload referencematerialer. Indtast tekst og brug {'@'}materialer til at kombinere dem frit. Eksempel: {'@'}Billede1 efterligner {'@'}Video1 med {'@'}Lyd1.",
            promptMaxLength: 'Prompten må højst være {count} tegn lang.',
            imageMaxCount: 'Du kan uploade op til {count} referencebilleder.',
            videoDurationRange: 'Denne referencevideo er {current} lang. Upload en video på mellem {min} og {max} sekunder.',
            videoMaxCount: 'Du kan uploade op til {count} referencevideoer.',
            videoTotalDuration: 'Den samlede videovarighed efter upload ville være {current}, hvilket overstiger grænsen på {max} sekunder.',
            audioDurationRange: 'Denne referencelyd er {current} lang. Upload lyd på mellem {min} og {max} sekunder.',
            audioMaxCount: 'Du kan uploade op til {count} referencelydklip.',
            audioTotalDuration: 'Den samlede lydvarighed efter upload ville være {current}, hvilket overstiger grænsen på {max} sekunder.',
            mediaTotalDuration: 'Den samlede varighed af referencevideoer og lyd efter upload ville være {current}, hvilket overstiger grænsen på {max} sekunder.',
            audioNeedsVisualReference: 'Lyd kan ikke bruges alene. Behold mindst ét referencebillede eller én referencevideo.',
            referenceRequired: 'Upload mindst ét referencebillede eller én referencevideo.',
            uploadHints: {
                image: 'Understotter 1-9 billeder, op til 3 videoer og op til 3 lydfiler (hver 2-15 sek.; samlet video- og lydvarighed beregnes separat, hver <= 15 sek.)',
                dance25: 'Understotter op til {imageCount} billeder, {videoCount} videoer og {audioCount} lydfiler (hver video/lyd {minDuration}-{maxDuration} sek.; samlet video- og lydvarighed beregnes separat, hver <= {totalDuration} sek.)',
            },
        },
        uploadStrip: {
            removeVideo: 'Fjern video',
            removeImage: 'Fjern billede',
            removeAudio: 'Fjern lyd',
        },
        toolTitles: {
            'video-motion-imitation': 'AI video-bevægelsesimitation',
            'video-face-swap': 'AI video-ansigtsbytning',
            'video-to-anime': 'AI video-til-anime-konverter',
            'video-subtitle-translate': 'AI undertekstoversættelse',
            'video-upscaler': 'AI video-forbedring',
            'video-background-remover': 'AI fjernelse af videobaggrund',
            'video-watermark-remover': 'AI fjernelse af vandmærke',
            'remove-video-subtitles': 'AI fjernelse af undertekster',
            'video-extender': 'AI video-forlænger',
            'image-background-changer': 'AI skift af billedbaggrund',
            'image-resizer': 'AI billedstørrelsesjustering',
            'image-text-translate': 'AI billedtekstoversættelse',
            'image-upscaler': 'AI billedkvalitetsforbedring',
            'photo-face-swap': 'Ansigtsudskiftning',
            'remove-text-image': 'AI fjernelse af tekst i billede',
            'ai-image-extender': 'AI billedudvidelse',
            'photo-restoration': 'Restaurering af gamle fotos',
            'ai-image-background-remover': 'AI fjernelse af billedbaggrund',
            'video-lip-sync': 'AI video-læbesynkronisering',
        },
        // Mine projekter
        myProject: 'Mine projekter',
        noProject: 'Ingen projekter',
        newProject: 'Nyt projekt',
        // Historik hover-handlinger
        addToInput: 'Tilføj til oprettelse',
        reAdd: 'Tilføj igen',
        imageEdit: 'Rediger billede',
        videoEdit: 'Rediger video',
        videoToolCannotUploadImage: 'Videoredigeringsværktøjer kan kun uploade videoer, ikke billeder',
        videoEditOnlySupportVideo: 'Videoredigering understøtter kun upload af videoer',
        videoAddedToTool: 'Video tilføjet til værktøj',
        switchedToImageMode: 'Skiftet til billede-til-billede-tilstand',
        switchedToVideoMode: 'Skiftet til videoredigeringstilstand',
        reEdit: 'Rediger igen',
        musicCannotReEdit: 'Musikproduktion kan ikke redigeres igen',
    },
    no: {
        importLink: 'Importer lenke',
        videoPreview: 'Videoforhåndsvisning',
        modeSelect: 'Velg modus',
        reselect: 'Velg på nytt',
        select: 'Velg',
        selectModel: 'Velg modell',
        openQuickSwitches: 'Åpne hurtigbrytere',
        quickSettings: {
            openSettings: 'Åpne innstillinger',
            aspectRatio: 'Sideforhold',
            outputCount: 'Antall utdata',
            resolution: 'Oppløsning',
            duration: 'Varighet',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Start',
        lastFrame: 'Slutt',
        keyframesUpload: {
            firstFrameAlt: 'Første bilde',
            lastFrameAlt: 'Siste bilde',
            removeFirstFrame: 'Fjern første bilde',
            removeLastFrame: 'Fjern siste bilde',
        },
        toolOptions: {
            mode: 'Modus',
            backgroundColor: 'Bakgrunnsfarge',
            outputFormat: 'Utdataformat',
            type: 'Type',
            extendDuration: 'Forlengelsesvarighet',
            backgroundDescription: 'Bakgrunnsbeskrivelse',
            aspectRatio: 'Sideforhold',
            translateTo: 'Oversett til',
        },
        toolOptionValues: {
            motionType: {
                move: 'Bevegelsesstyrt',
                replace: 'Karakterbytte',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D-animasjon',
                cyberpunk: 'Cyberpunk',
                comic: 'Tegneserie',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Skriv inn en prompt som beskriver hva som skal forlenges i videoen...',
        },
        languageNames: {
            zh: 'Kinesisk (forenklet)',
            tw: 'Kinesisk (tradisjonell)',
            en: 'Engelsk',
            ja: 'Japansk',
            ko: 'Koreansk',
            es: 'Spansk',
            fr: 'Fransk',
            de: 'Tysk',
            ru: 'Russisk',
            pl: 'Polsk',
            pt: 'Portugisisk',
            it: 'Italiensk',
            ar: 'Arabisk',
            th: 'Thai',
            da: 'Dansk',
            no: 'Norsk bokmål',
            nl: 'Nederlandsk',
            id: 'Indonesisk',
            tr: 'Tyrkisk',
        },
        promptPlaceholder: 'Beskriv hva du vil generere',
        modePromptPlaceholders: {
            chat: 'Hva vil du snakke om, eller hva vil du få gjort?',
            image: 'Beskriv bildet du vil generere, for eksempel motiv, stil og scene',
            video: 'Beskriv videoen du vil generere, for eksempel opptak, bevegelse og scene',
            music: 'Beskriv musikkstilen, stemningen eller temaet',
        },
        promptPlaceholderToday: 'Hva vil du generere i dag?',
        positivePrompt: 'Positiv prompt',
        negativePrompt: 'Negativ prompt',
        negativePromptPlaceholder: 'Skriv inn negativ prompt',
        videoModeMulti: 'Generering med flere bilder',
        videoModeAddLastFrame: 'Legg til siste bilde',
        credits: '{count}',
        uploadingWait: 'Laster opp, vennligst vent til det er ferdig før du limer inn.',
        noEmptySlot: 'Ingen ledige plasser for å lime inn bilder.',
        maxPasteLimit: 'Du kan laste opp opptil {count} filer.',
        formatSupport: 'Gjeldende opprettelsesmodus støtter ikke denne filtypen: ',
        andOthers: ' og {count} andre filer',
        notSupportPaste: 'Gjeldende verktøy støtter ikke liming av bilder.',
        onlyOneVideo: 'Bare 1 videofil kan lastes opp.',
        videoTooLargePrompt: 'Videofilen er for stor, vennligst last opp en video innenfor {size}.',
        templateSlotLimit: 'Hver malplass støtter bare 1 bilde.',
        uploadingWaitDrag: 'Laster opp, vennligst vent til det er ferdig før du drar.',
        uploadTypeCheck: 'Gjeldende opprettelsesmodus støtter ikke denne filtypen.',
        imageSizeLimitPrompt: 'Bildestørrelsen kan ikke overstige 100 MB.',
        imageResolutionLimitPrompt: 'Bildeoppløsningen er for stor, den lengste siden kan ikke overstige 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Bilde',
            videoGenerate: 'Video',
            musicGenerate: 'Musikk',
            imageEdit: 'Bildebehandling',
            videoEdit: 'Videoredigering',
            imageTemplate: 'Bildemaler',
            videoTemplate: 'Videomaler',
            tools: 'Verktøy',
        },
        secondaryTabs: {
            textToImage: 'Tekst til bilde',
            imageToImage: 'Bilde til bilde',
            characterToImage: 'Karakter til bilde',
            textToVideo: 'Tekst til video',
            imageToVideo: 'Bilde til video',
            keyframes: 'Første/siste bilde',
            characterToVideo: 'Karakter til video',
            videoEdit: 'Videoredigering',
            voice: 'Vokal',
            pureMusic: 'Instrumental musikk',
        },
        seedanceVideoModes: {
            allRound: 'Allsidig referanse',
        },
        tertiaryTabs: {
            boyVoice: 'Mannlig stemme',
            girlVoice: 'Kvinnelig stemme',
        },
        configGroups: {
            voiceGender: 'Stemmetype',
            tags: 'Tagger',
        },
        audioGenerated: 'Lyd generert',
        successAudioLinkAdded: 'Lydlenke lagt til',
        audio: 'Lyd',
        audioLink: 'Lydlenke',
        uploadAudio: 'Last opp lyd',
        addAudio: 'Legg til lyd',
        musicPrompt: {
            removeTag: 'Fjern tagg',
            creativeThemeTitle: 'Kreativt tema',
            creativeThemePlaceholder: 'Beskriv musikkstil, stemning eller tema',
            lyricsTitle: 'Skriv inn sangtekst',
            lyricsPlaceholder: 'Skriv inn sangtekst...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Bilde',
            audio: 'Lyd',
            baseImage: 'Basisbilde',
            face: 'Ansikt',
        },
        seedanceAlmighty: {
            panelTitle: 'Referanseinnhold',
            emptyTitle: 'Last opp referanser',
            dragMaterialsHere: 'Dra materialer hit',
            promptPlaceholder: "Last opp 1-12 referansematerialer. Skriv inn tekst og bruk {'@'}materialer for a kombinere dem fritt. Eksempel: {'@'}Bilde1 etterligner {'@'}Video1 med {'@'}Lyd1.",
            promptPlaceholderDance25: "Last opp referansematerialer. Skriv inn tekst og bruk {'@'}materialer for a kombinere dem fritt. Eksempel: {'@'}Bilde1 etterligner {'@'}Video1 med {'@'}Lyd1.",
            promptMaxLength: 'Prompten kan ikke være lengre enn {count} tegn.',
            imageMaxCount: 'Du kan laste opp opptil {count} referansebilder.',
            videoDurationRange: 'Denne referansevideoen er {current} lang. Last opp en video som er mellom {min} og {max} sekunder.',
            videoMaxCount: 'Du kan laste opp opptil {count} referansevideoer.',
            videoTotalDuration: 'Samlet videovarighet etter opplasting ville blitt {current}, som overstiger grensen på {max} sekunder.',
            audioDurationRange: 'Denne referanselyden er {current} lang. Last opp lyd som er mellom {min} og {max} sekunder.',
            audioMaxCount: 'Du kan laste opp opptil {count} referanselydklipp.',
            audioTotalDuration: 'Samlet lydvarighet etter opplasting ville blitt {current}, som overstiger grensen på {max} sekunder.',
            mediaTotalDuration: 'Samlet varighet for referansevideoer og lyd etter opplasting ville blitt {current}, som overstiger grensen på {max} sekunder.',
            audioNeedsVisualReference: 'Lyd kan ikke brukes alene. Behold minst ett referansebilde eller én referansevideo.',
            referenceRequired: 'Last opp minst ett referansebilde eller én referansevideo.',
            uploadHints: {
                image: 'Stotter opplasting av 1-9 bilder, opptil 3 videoer og opptil 3 lydfiler (hver 2-15 sek; samlet video- og lydvarighet beregnes separat, hver <= 15 sek)',
                dance25: 'Stotter opptil {imageCount} bilder, {videoCount} videoer og {audioCount} lydfiler (hver video/lyd {minDuration}-{maxDuration} sek; samlet video- og lydvarighet beregnes separat, hver <= {totalDuration} sek)',
            },
        },
        uploadStrip: {
            removeVideo: 'Fjern video',
            removeImage: 'Fjern bilde',
            removeAudio: 'Fjern lyd',
        },
        toolTitles: {
            'video-motion-imitation': 'AI video-bevegelsesimitasjon',
            'video-face-swap': 'AI video-ansiktsbytte',
            'video-to-anime': 'AI video-til-anime-konverter',
            'video-subtitle-translate': 'AI undertekstoversettelse',
            'video-upscaler': 'AI video-forbedring',
            'video-background-remover': 'AI fjerning av videobakgrunn',
            'video-watermark-remover': 'AI fjerning av vannmerke',
            'remove-video-subtitles': 'AI fjerning av undertekster',
            'video-extender': 'AI video-forlenger',
            'image-background-changer': 'AI bakgrunnsbytter for bilder',
            'image-resizer': 'AI bildestørrelsejustering',
            'image-text-translate': 'AI bilde-tekstoversettelse',
            'image-upscaler': 'AI bildekvalitetsforbedring',
            'photo-face-swap': 'Ansiktsbytte',
            'remove-text-image': 'AI fjerning av tekst i bilde',
            'ai-image-extender': 'AI bildeutvidelse',
            'photo-restoration': 'Restaurering av gamle bilder',
            'ai-image-background-remover': 'AI fjerning av bakgrunn i bilder',
            'video-lip-sync': 'AI video-leppesynkronisering',
        },
        // Mine prosjekter
        myProject: 'Mine prosjekter',
        noProject: 'Ingen prosjekter',
        newProject: 'Nytt prosjekt',
        // Historikk hover-handlinger
        addToInput: 'Legg til oppretting',
        reAdd: 'Legg til på nytt',
        imageEdit: 'Rediger bilde',
        videoEdit: 'Rediger video',
        videoToolCannotUploadImage: 'Videoredigeringsverktøy kan bare laste opp videoer, ikke bilder',
        videoEditOnlySupportVideo: 'Videoredigering støtter bare opplasting av videoer',
        videoAddedToTool: 'Video lagt til verktøy',
        switchedToImageMode: 'Byttet til bilde-til-bilde-modus',
        switchedToVideoMode: 'Byttet til videoredigeringsmodus',
        reEdit: 'Rediger på nytt',
        musicCannotReEdit: 'Musikkproduksjon kan ikke redigeres på nytt',
    },
    nl: {
        importLink: 'Link importeren',
        videoPreview: 'Videovoorbeeld',
        modeSelect: 'Modusselectie',
        reselect: 'Opnieuw selecteren',
        select: 'Selecteren',
        selectModel: 'Model selecteren',
        openQuickSwitches: 'Snelle schakelaars openen',
        quickSettings: {
            openSettings: 'Instellingen openen',
            aspectRatio: 'Beeldverhouding',
            outputCount: 'Aantal outputs',
            resolution: 'Resolutie',
            duration: 'Duur',
            secondsLabel: '{value}s',
        },
        avatar: 'Avatar',
        firstFrame: 'Start',
        lastFrame: 'Einde',
        keyframesUpload: {
            firstFrameAlt: 'Eerste frame',
            lastFrameAlt: 'Laatste frame',
            removeFirstFrame: 'Eerste frame verwijderen',
            removeLastFrame: 'Laatste frame verwijderen',
        },
        toolOptions: {
            mode: 'Modus',
            backgroundColor: 'Achtergrondkleur',
            outputFormat: 'Uitvoerformaat',
            type: 'Type',
            extendDuration: 'Verlengingsduur',
            backgroundDescription: 'Achtergrondbeschrijving',
            aspectRatio: 'Beeldverhouding',
            translateTo: 'Vertalen naar',
        },
        toolOptionValues: {
            motionType: {
                move: 'Bewegingsgestuurd',
                replace: 'Personage wisselen',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D-animatie',
                cyberpunk: 'Cyberpunk',
                comic: 'Strip',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Beschrijf in de prompt wat je in de video wilt verlengen...',
        },
        languageNames: {
            zh: 'Chinees (vereenvoudigd)',
            tw: 'Chinees (traditioneel)',
            en: 'Engels',
            ja: 'Japans',
            ko: 'Koreaans',
            es: 'Spaans',
            fr: 'Frans',
            de: 'Duits',
            ru: 'Russisch',
            pl: 'Pools',
            pt: 'Portugees',
            it: 'Italiaans',
            ar: 'Arabisch',
            th: 'Thais',
            da: 'Deens',
            no: 'Noors (Bokmål)',
            nl: 'Nederlands',
            id: 'Indonesisch',
            tr: 'Turks',
        },
        promptPlaceholder: 'Beschrijf wat je wilt genereren',
        modePromptPlaceholders: {
            chat: 'Waar wil je over praten of wat wil je gedaan krijgen?',
            image: 'Beschrijf de afbeelding die je wilt genereren, zoals onderwerp, stijl en scène',
            video: 'Beschrijf de video die je wilt genereren, zoals shots, beweging en scène',
            music: 'Beschrijf de muziekstijl, sfeer of het thema',
        },
        promptPlaceholderToday: 'Wat wil je vandaag genereren?',
        positivePrompt: 'Positieve prompt',
        negativePrompt: 'Negatieve prompt',
        negativePromptPlaceholder: 'Voer negatieve prompt in',
        videoModeMulti: 'Genereren met meerdere afbeeldingen',
        videoModeAddLastFrame: 'Laatste frame toevoegen',
        credits: '{count}',
        uploadingWait: 'Bezig met uploaden, wacht tot het klaar is voordat u plakt.',
        noEmptySlot: 'Geen lege slots beschikbaar om afbeeldingen te plakken.',
        maxPasteLimit: 'Je kunt maximaal {count} bestanden uploaden.',
        formatSupport: 'De huidige aanmaakmodus ondersteunt dit bestandstype niet: ',
        andOthers: ' en {count} andere bestanden',
        notSupportPaste: 'Huidige tool ondersteunt het plakken van afbeeldingen niet.',
        onlyOneVideo: 'Er kan slechts 1 videobestand worden geüpload.',
        videoTooLargePrompt: 'Videobestand is te groot, upload een video binnen {size}.',
        templateSlotLimit: 'Elk sjabloonslot ondersteunt slechts 1 afbeelding.',
        uploadingWaitDrag: 'Bezig met uploaden, wacht tot het klaar is voordat u sleept.',
        uploadTypeCheck: 'De huidige aanmaakmodus ondersteunt dit bestandstype niet.',
        imageSizeLimitPrompt: 'Afbeeldingsgrootte mag niet groter zijn dan 100 MB.',
        imageResolutionLimitPrompt: 'Afbeeldingsresolutie is te groot, de langste zijde mag niet groter zijn dan 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Afbeelding',
            videoGenerate: 'Video',
            musicGenerate: 'Muziek',
            imageEdit: 'Afbeelding bewerken',
            videoEdit: 'Video bewerken',
            imageTemplate: 'Afbeeldingssjablonen',
            videoTemplate: 'Videosjablonen',
            tools: 'Gereedschap',
        },
        secondaryTabs: {
            textToImage: 'Tekst naar afbeelding',
            imageToImage: 'Afbeelding naar afbeelding',
            characterToImage: 'Personage naar afbeelding',
            textToVideo: 'Tekst naar video',
            imageToVideo: 'Afbeelding naar video',
            keyframes: 'Eerste/laatste frame',
            characterToVideo: 'Personage naar video',
            videoEdit: 'Video bewerken',
            voice: 'Vocaal',
            pureMusic: 'Instrumentale muziek',
        },
        seedanceVideoModes: {
            allRound: 'Alles-in-één referentie',
        },
        tertiaryTabs: {
            boyVoice: 'Mannelijke stem',
            girlVoice: 'Vrouwelijke stem',
        },
        configGroups: {
            voiceGender: 'Stemtype',
            tags: 'Tags',
        },
        audioGenerated: 'Audio gegenereerd',
        successAudioLinkAdded: 'Audiolink toegevoegd',
        audio: 'Audio',
        audioLink: 'Audiolink',
        uploadAudio: 'Audio uploaden',
        addAudio: 'Audio toevoegen',
        musicPrompt: {
            removeTag: 'Tag verwijderen',
            creativeThemeTitle: 'Creatief thema',
            creativeThemePlaceholder:
                'Beschrijf de muziekstijl, sfeer of het thema',
            lyricsTitle: 'Voer songtekst in',
            lyricsPlaceholder: 'Voer songtekst in...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Afbeelding',
            audio: 'Audio',
            baseImage: 'Basisafbeelding',
            face: 'Gezicht',
        },
        seedanceAlmighty: {
            panelTitle: 'Referentie-inhoud',
            emptyTitle: 'Referenties uploaden',
            dragMaterialsHere: 'Sleep materialen hierheen',
            promptPlaceholder: "Upload 1-12 referentiematerialen. Voer tekst in en tag {'@'}materialen om ze vrij te combineren. Voorbeeld: {'@'}Afbeelding1 bootst {'@'}Video1 na met {'@'}Audio1.",
            promptPlaceholderDance25: "Upload referentiematerialen. Voer tekst in en tag {'@'}materialen om ze vrij te combineren. Voorbeeld: {'@'}Afbeelding1 bootst {'@'}Video1 na met {'@'}Audio1.",
            promptMaxLength: 'De prompt mag niet langer zijn dan {count} tekens.',
            imageMaxCount: 'Je kunt maximaal {count} referentieafbeeldingen uploaden.',
            videoDurationRange: 'Deze referentievideo duurt {current}. Upload een video van tussen de {min} en {max} seconden.',
            videoMaxCount: 'Je kunt maximaal {count} referentievideoclips uploaden.',
            videoTotalDuration: 'De totale videoduur na upload zou {current} zijn, wat de limiet van {max} seconden overschrijdt.',
            audioDurationRange: 'Dit referentieaudiofragment duurt {current}. Upload audio van tussen de {min} en {max} seconden.',
            audioMaxCount: 'Je kunt maximaal {count} referentieaudiofragmenten uploaden.',
            audioTotalDuration: 'De totale audioduur na upload zou {current} zijn, wat de limiet van {max} seconden overschrijdt.',
            mediaTotalDuration: 'De totale duur van referentievideo’s en audio na upload zou {current} zijn, wat de limiet van {max} seconden overschrijdt.',
            audioNeedsVisualReference: 'Audio kan niet afzonderlijk worden gebruikt. Houd ten minste één referentieafbeelding of referentievideoclip.',
            referenceRequired: 'Upload ten minste één referentieafbeelding of referentievideoclip.',
            uploadHints: {
                image: 'Ondersteunt 1-9 afbeeldingen, maximaal 3 videos en maximaal 3 audiobestanden (elk 2-15 sec.; totale video- en audioduur worden apart berekend, elk <= 15 sec.)',
                dance25: 'Ondersteunt maximaal {imageCount} afbeeldingen, {videoCount} videos en {audioCount} audiobestanden (elke video/audio {minDuration}-{maxDuration} sec.; totale video- en audioduur worden apart berekend, elk <= {totalDuration} sec.)',
            },
        },
        uploadStrip: {
            removeVideo: 'Video verwijderen',
            removeImage: 'Afbeelding verwijderen',
            removeAudio: 'Audio verwijderen',
        },
        toolTitles: {
            'video-motion-imitation': 'AI video-bewegingsimitatie',
            'video-face-swap': 'AI video-gezichtswissel',
            'video-to-anime': 'AI video-naar-anime-converter',
            'video-subtitle-translate': 'AI ondertiteling vertaling',
            'video-upscaler': 'AI videoverbetering',
            'video-background-remover': 'AI video-achtergrondverwijdering',
            'video-watermark-remover': 'AI watermerkverwijderaar',
            'remove-video-subtitles': 'AI ondertitelverwijdering',
            'video-extender': 'AI videoverlenger',
            'image-background-changer': 'AI achtergrondwisselaar voor afbeeldingen',
            'image-resizer': 'AI afbeeldingsresizer',
            'image-text-translate': 'AI afbeeldingstekstvertaling',
            'image-upscaler': 'AI beeldkwaliteitsverbetering',
            'photo-face-swap': 'Gezichtsvervanging',
            'remove-text-image': 'AI tekstverwijdering uit afbeelding',
            'ai-image-extender': 'AI afbeeldingsuitbreiding',
            'photo-restoration': 'Restauratie van oude foto\'s',
            'ai-image-background-remover': 'AI achtergrondverwijderaar voor afbeeldingen',
            'video-lip-sync': 'AI video-lipsynchronisatie',
        },
        // Mijn projecten
        myProject: 'Mijn projecten',
        noProject: 'Geen projecten',
        newProject: 'Nieuw project',
        // Geschiedenis hover-acties
        addToInput: 'Toevoegen aan creatie',
        reAdd: 'Opnieuw toevoegen',
        imageEdit: 'Afbeelding bewerken',
        videoEdit: 'Video bewerken',
        videoToolCannotUploadImage: 'Videobewerkingstools kunnen alleen video\'s uploaden, geen afbeeldingen',
        videoEditOnlySupportVideo: 'Videobewerking ondersteunt alleen het uploaden van video\'s',
        videoAddedToTool: 'Video toegevoegd aan tool',
        switchedToImageMode: 'Overgeschakeld naar afbeelding-naar-afbeelding-modus',
        switchedToVideoMode: 'Overgeschakeld naar videobewerkingsmodus',
        reEdit: 'Opnieuw bewerken',
        musicCannotReEdit: 'Muziekcreatie kan niet opnieuw worden bewerkt',
    },
    id: {
        importLink: 'Impor tautan',
        videoPreview: 'Pratinjau video',
        modeSelect: 'Pilih Mode',
        reselect: 'Pilih ulang',
        select: 'Pilih',
        selectModel: 'Pilih model',
        openQuickSwitches: 'Buka sakelar cepat',
        quickSettings: {
            openSettings: 'Buka pengaturan',
            aspectRatio: 'Rasio aspek',
            outputCount: 'Jumlah output',
            resolution: 'Resolusi',
            duration: 'Durasi',
            secondsLabel: '{value}d',
        },
        avatar: 'Avatar',
        firstFrame: 'Mulai',
        lastFrame: 'Selesai',
        keyframesUpload: {
            firstFrameAlt: 'Frame pertama',
            lastFrameAlt: 'Frame terakhir',
            removeFirstFrame: 'Hapus frame pertama',
            removeLastFrame: 'Hapus frame terakhir',
        },
        toolOptions: {
            mode: 'Mode',
            backgroundColor: 'Warna latar belakang',
            outputFormat: 'Format keluaran',
            type: 'Tipe',
            extendDuration: 'Durasi perpanjangan',
            backgroundDescription: 'Deskripsi latar belakang',
            aspectRatio: 'Rasio aspek',
            translateTo: 'Terjemahkan ke',
        },
        toolOptionValues: {
            motionType: {
                move: 'Didorong oleh gerakan',
                replace: 'Penggantian karakter',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': 'Animasi 3D',
                cyberpunk: 'Cyberpunk',
                comic: 'Komik',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Masukkan prompt untuk menjelaskan konten yang ingin Anda perpanjang dalam video...',
        },
        languageNames: {
            zh: 'Tionghoa (Sederhana)',
            tw: 'Tionghoa (Tradisional)',
            en: 'Inggris',
            ja: 'Jepang',
            ko: 'Korea',
            es: 'Spanyol',
            fr: 'Prancis',
            de: 'Jerman',
            ru: 'Rusia',
            pl: 'Polandia',
            pt: 'Portugis',
            it: 'Italia',
            ar: 'Arab',
            th: 'Thailand',
            da: 'Denmark',
            no: 'Norwegia (Bokmål)',
            nl: 'Belanda',
            id: 'Indonesia',
            tr: 'Turki',
        },
        promptPlaceholder: 'Jelaskan apa yang ingin Anda hasilkan',
        modePromptPlaceholders: {
            chat: 'Anda ingin membahas apa atau ingin menyelesaikan apa?',
            image: 'Jelaskan gambar yang ingin Anda hasilkan, seperti subjek, gaya, dan adegan',
            video: 'Jelaskan video yang ingin Anda hasilkan, seperti shot, gerakan, dan adegan',
            music: 'Jelaskan gaya musik, suasana, atau temanya',
        },
        promptPlaceholderToday: 'Hari ini kamu ingin menghasilkan apa?',
        positivePrompt: 'Prompt positif',
        negativePrompt: 'Prompt negatif',
        negativePromptPlaceholder: 'Masukkan prompt negatif',
        videoModeMulti: 'Generasi multi-gambar',
        videoModeAddLastFrame: 'Tambahkan frame terakhir',
        credits: '{count}',
        uploadingWait: 'Sedang mengunggah, harap tunggu hingga selesai sebelum menempel.',
        noEmptySlot: 'Tidak ada slot kosong yang tersedia untuk menempel gambar.',
        maxPasteLimit: 'Anda dapat mengunggah hingga {count} file.',
        formatSupport: 'Mode pembuatan saat ini tidak mendukung jenis file ini: ',
        andOthers: ' dan {count} file lainnya',
        notSupportPaste: 'Alat saat ini tidak mendukung penempelan gambar.',
        onlyOneVideo: 'Hanya 1 file video yang dapat diunggah.',
        videoTooLargePrompt: 'File video terlalu besar, harap unggah video dalam {size}.',
        templateSlotLimit: 'Setiap slot templat hanya mendukung 1 gambar.',
        uploadingWaitDrag: 'Sedang mengunggah, harap tunggu hingga selesai sebelum menyeret.',
        uploadTypeCheck: 'Mode pembuatan saat ini tidak mendukung jenis file ini.',
        imageSizeLimitPrompt: 'Ukuran gambar tidak boleh melebihi 100 MB.',
        imageResolutionLimitPrompt: 'Resolusi gambar terlalu besar, sisi terpanjang tidak boleh melebihi 4096 px.',
        primaryTabs: {
            chat: 'Chat',
            imageGenerate: 'Gambar',
            videoGenerate: 'Video',
            musicGenerate: 'Musik',
            imageEdit: 'Edit gambar',
            videoEdit: 'Edit video',
            imageTemplate: 'Template gambar',
            videoTemplate: 'Template video',
            tools: 'Alat',
        },
        secondaryTabs: {
            textToImage: 'Teks ke gambar',
            imageToImage: 'Gambar ke gambar',
            characterToImage: 'Karakter ke gambar',
            textToVideo: 'Teks ke video',
            imageToVideo: 'Gambar ke video',
            keyframes: 'Frame pertama/terakhir',
            characterToVideo: 'Karakter ke video',
            videoEdit: 'Edit video',
            voice: 'Vokal',
            pureMusic: 'Musik instrumental',
        },
        seedanceVideoModes: {
            allRound: 'Referensi serbaguna',
        },
        tertiaryTabs: {
            boyVoice: 'Suara pria',
            girlVoice: 'Suara wanita',
        },
        configGroups: {
            voiceGender: 'Jenis suara',
            tags: 'Tag',
        },
        audioGenerated: 'Audio dihasilkan',
        successAudioLinkAdded: 'Tautan audio ditambahkan',
        audio: 'Audio',
        audioLink: 'Tautan audio',
        uploadAudio: 'Unggah audio',
        addAudio: 'Tambah audio',
        musicPrompt: {
            removeTag: 'Hapus tag',
            creativeThemeTitle: 'Tema kreatif',
            creativeThemePlaceholder:
                'Jelaskan gaya, suasana, atau tema musik',
            lyricsTitle: 'Masukkan lirik',
            lyricsPlaceholder: 'Masukkan lirik...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Gambar',
            audio: 'Audio',
            baseImage: 'Gambar dasar',
            face: 'Wajah',
        },
        seedanceAlmighty: {
            panelTitle: 'Konten referensi',
            emptyTitle: 'Unggah referensi',
            dragMaterialsHere: 'Seret materi ke sini',
            promptPlaceholder: "Unggah 1-12 aset referensi. Masukkan teks dan tandai aset dengan {'@'} agar bisa digabungkan bebas. Contoh: {'@'}Gambar1 meniru {'@'}Video1 dengan {'@'}Audio1.",
            promptPlaceholderDance25: "Unggah aset referensi. Masukkan teks dan tandai aset dengan {'@'} agar bisa digabungkan bebas. Contoh: {'@'}Gambar1 meniru {'@'}Video1 dengan {'@'}Audio1.",
            promptMaxLength: 'Prompt tidak boleh lebih dari {count} karakter.',
            imageMaxCount: 'Anda dapat mengunggah hingga {count} gambar referensi.',
            videoDurationRange: 'Video referensi ini berdurasi {current}. Unggah video dengan durasi antara {min} dan {max} detik.',
            videoMaxCount: 'Anda dapat mengunggah hingga {count} video referensi.',
            videoTotalDuration: 'Total durasi video setelah diunggah akan menjadi {current}, melebihi batas {max} detik.',
            audioDurationRange: 'Audio referensi ini berdurasi {current}. Unggah audio dengan durasi antara {min} dan {max} detik.',
            audioMaxCount: 'Anda dapat mengunggah hingga {count} audio referensi.',
            audioTotalDuration: 'Total durasi audio setelah diunggah akan menjadi {current}, melebihi batas {max} detik.',
            mediaTotalDuration: 'Total durasi video dan audio referensi setelah diunggah akan menjadi {current}, melebihi batas {max} detik.',
            audioNeedsVisualReference: 'Audio tidak boleh digunakan sendiri. Pertahankan setidaknya satu gambar referensi atau video referensi.',
            referenceRequired: 'Unggah setidaknya satu gambar referensi atau video referensi.',
            uploadHints: {
                image: 'Mendukung 1-9 gambar, hingga 3 video, dan hingga 3 audio (masing-masing 2-15 detik; total durasi video dan audio dihitung terpisah, masing-masing <= 15 detik)',
                dance25: 'Mendukung hingga {imageCount} gambar, {videoCount} video, dan {audioCount} audio (setiap video/audio {minDuration}-{maxDuration} detik; total durasi video dan audio dihitung terpisah, masing-masing <= {totalDuration} detik)',
            },
        },
        uploadStrip: {
            removeVideo: 'Hapus video',
            removeImage: 'Hapus gambar',
            removeAudio: 'Hapus audio',
        },
        toolTitles: {
            'video-motion-imitation': 'Imitasi gerakan video AI',
            'video-face-swap': 'Tukar wajah video AI',
            'video-to-anime': 'Pengonversi video ke anime AI',
            'video-subtitle-translate': 'Terjemahan subtitle AI',
            'video-upscaler': 'Peningkatan video AI',
            'video-background-remover': 'Penghapus latar belakang video AI',
            'video-watermark-remover': 'Penghapus watermark AI',
            'remove-video-subtitles': 'Penghapus subtitle AI',
            'video-extender': 'Pemanjang video AI',
            'image-background-changer': 'Pengganti latar belakang gambar AI',
            'image-resizer': 'Pengubah ukuran gambar AI',
            'image-text-translate': 'Terjemahan teks pada gambar AI',
            'image-upscaler': 'Peningkatan kualitas gambar AI',
            'photo-face-swap': 'Penggantian wajah',
            'remove-text-image': 'Penghapus teks pada gambar AI',
            'ai-image-extender': 'Perluasan gambar AI',
            'photo-restoration': 'Restorasi foto lama',
            'ai-image-background-remover': 'Penghapus latar belakang gambar AI',
            'video-lip-sync': 'Sinkronisasi bibir video AI',
        },
        // Proyek Saya
        myProject: 'Proyek Saya',
        noProject: 'Tidak ada proyek',
        newProject: 'Proyek Baru',
        // Aksi hover riwayat
        addToInput: 'Tambahkan ke kreasi',
        reAdd: 'Tambahkan lagi',
        imageEdit: 'Edit gambar',
        videoEdit: 'Edit video',
        videoToolCannotUploadImage: 'Alat pengeditan video hanya dapat mengunggah video, bukan gambar',
        videoEditOnlySupportVideo: 'Pengeditan video hanya mendukung mengunggah video',
        videoAddedToTool: 'Video ditambahkan ke alat',
        switchedToImageMode: 'Beralih ke mode gambar ke gambar',
        switchedToVideoMode: 'Beralih ke mode pengeditan video',
        reEdit: 'Edit ulang',
        musicCannotReEdit: 'Kreasi musik tidak dapat diedit ulang',
    },
    tr: {
        importLink: 'Bağlantıyı içe aktar',
        videoPreview: 'Video önizleme',
        modeSelect: 'Mod Seçimi',
        reselect: 'Yeniden seç',
        select: 'Seç',
        selectModel: 'Model seç',
        openQuickSwitches: 'Hızlı anahtarları aç',
        quickSettings: {
            openSettings: 'Ayarları aç',
            aspectRatio: 'En-boy oranı',
            outputCount: 'Çıktı sayısı',
            resolution: 'Çözünürlük',
            duration: 'Süre',
            secondsLabel: '{value}sn',
        },
        avatar: 'Avatar',
        firstFrame: 'Başlangıç',
        lastFrame: 'Bitiş',
        keyframesUpload: {
            firstFrameAlt: 'İlk kare',
            lastFrameAlt: 'Son kare',
            removeFirstFrame: 'İlk kareyi kaldır',
            removeLastFrame: 'Son kareyi kaldır',
        },
        toolOptions: {
            mode: 'Mod',
            backgroundColor: 'Arka plan rengi',
            outputFormat: 'Çıktı formatı',
            type: 'Tür',
            extendDuration: 'Uzatma süresi',
            backgroundDescription: 'Arka plan açıklaması',
            aspectRatio: 'En-boy oranı',
            translateTo: 'Şuna çevir',
        },
        toolOptionValues: {
            motionType: {
                move: 'Hareket odaklı',
                replace: 'Karakter değişimi',
            },
            videoExtenderStyle: {
                anime: 'Anime',
                '3dAnimation': '3D animasyon',
                cyberpunk: 'Siberpunk',
                comic: 'Çizgi roman',
            },
        },
        toolPrompts: {
            videoExtenderPlaceholder:
                'Videoda uzatmak istediğiniz içeriği istemde açıklayın...',
        },
        languageNames: {
            zh: 'Çince (Basitleştirilmiş)',
            tw: 'Çince (Geleneksel)',
            en: 'İngilizce',
            ja: 'Japonca',
            ko: 'Korece',
            es: 'İspanyolca',
            fr: 'Fransızca',
            de: 'Almanca',
            ru: 'Rusça',
            pl: 'Lehçe',
            pt: 'Portekizce',
            it: 'İtalyanca',
            ar: 'Arapça',
            th: 'Tayca',
            da: 'Danca',
            no: 'Norveççe (Bokmål)',
            nl: 'Hollandaca',
            id: 'Endonezce',
            tr: 'Türkçe',
        },
        promptPlaceholder: 'Ne üretmek istediğini açıklayın',
        modePromptPlaceholders: {
            chat: 'Ne hakkında konuşmak istiyorsun veya ne yapmak istiyorsun?',
            image: 'Üretmek istediğin görseli, örneğin konu, stil ve sahneyle birlikte açıkla',
            video: 'Üretmek istediğin videoyu, örneğin çekimler, hareket ve sahneyle birlikte açıkla',
            music: 'Müzik tarzını, ruh halini veya temayı açıkla',
        },
        promptPlaceholderToday: 'Bugün ne oluşturmak istiyorsun?',
        positivePrompt: 'Pozitif istem',
        negativePrompt: 'Negatif istem',
        negativePromptPlaceholder: 'Negatif istemi girin',
        videoModeMulti: 'Çoklu görsel üretimi',
        videoModeAddLastFrame: 'Son kareyi ekle',
        credits: '{count}',
        uploadingWait: 'Yükleniyor, yapıştırmadan önce lütfen bitmesini bekleyin.',
        noEmptySlot: 'Resim yapıştırmak için boş yuva yok.',
        maxPasteLimit: 'En fazla {count} dosya yükleyebilirsiniz.',
        formatSupport: 'Mevcut oluşturma modu bu dosya türünü desteklemiyor: ',
        andOthers: ' ve diğer {count} dosya',
        notSupportPaste: 'Mevcut araç resim yapıştırmayı desteklemiyor.',
        onlyOneVideo: 'Yalnızca 1 video dosyası yüklenebilir.',
        videoTooLargePrompt: 'Video dosyası çok büyük, lütfen {size} içinde bir video yükleyin.',
        templateSlotLimit: 'Her şablon yuvası yalnızca 1 resmi destekler.',
        uploadingWaitDrag: 'Yükleniyor, sürüklemeden önce lütfen bitmesini bekleyin.',
        uploadTypeCheck: 'Mevcut oluşturma modu bu dosya türünü desteklemiyor.',
        imageSizeLimitPrompt: 'Resim boyutu 100 MB\'ı aşamaz.',
        imageResolutionLimitPrompt: 'Resim çözünürlüğü çok büyük, en uzun kenar 4096 pikseli aşamaz.',
        primaryTabs: {
            chat: 'Sohbet',
            imageGenerate: 'Görsel',
            videoGenerate: 'Video',
            musicGenerate: 'Müzik',
            imageEdit: 'Görsel düzenleme',
            videoEdit: 'Video düzenleme',
            imageTemplate: 'Görsel şablonları',
            videoTemplate: 'Video şablonları',
            tools: 'Araçlar',
        },
        secondaryTabs: {
            textToImage: 'Metinden görsele',
            imageToImage: 'Görselden görsele',
            characterToImage: 'Karakterden görsele',
            textToVideo: 'Metinden videoya',
            imageToVideo: 'Görselden videoya',
            keyframes: 'İlk/son kare',
            characterToVideo: 'Karakterden videoya',
            videoEdit: 'Video düzenleme',
            voice: 'Vokal',
            pureMusic: 'Enstrümantal müzik',
        },
        seedanceVideoModes: {
            allRound: 'Çok yönlü referans',
        },
        tertiaryTabs: {
            boyVoice: 'Erkek sesi',
            girlVoice: 'Kadın sesi',
        },
        configGroups: {
            voiceGender: 'Ses türü',
            tags: 'Etiketler',
        },
        audioGenerated: 'Ses oluşturuldu',
        successAudioLinkAdded: 'Ses bağlantısı eklendi',
        audio: 'Ses',
        audioLink: 'Ses bağlantısı',
        uploadAudio: 'Ses yükle',
        addAudio: 'Ses ekle',
        musicPrompt: {
            removeTag: 'Etiketi kaldır',
            creativeThemeTitle: 'Yaratıcı tema',
            creativeThemePlaceholder:
                'Müzik tarzını, ruh halini veya temayı açıklayın',
            lyricsTitle: 'Şarkı sözlerini girin',
            lyricsPlaceholder: 'Şarkı sözlerini girin...',
        },
        uploadLabels: {
            video: 'Video',
            image: 'Görsel',
            audio: 'Ses',
            baseImage: 'Temel görsel',
            face: 'Yüz',
        },
        seedanceAlmighty: {
            panelTitle: 'Referans icerigi',
            emptyTitle: 'Referans yukle',
            dragMaterialsHere: 'Malzemeleri buraya surukleyin',
            promptPlaceholder: "1-12 referans materyali yukleyin. Metin girin ve {'@'}materyalleri ekleyerek ozgurce birlestirin. Ornek: {'@'}Gorsel1, {'@'}Video1 i {'@'}Ses1 ile taklit eder.",
            promptPlaceholderDance25: "Referans materyalleri yukleyin. Metin girin ve {'@'}materyalleri ekleyerek ozgurce birlestirin. Ornek: {'@'}Gorsel1, {'@'}Video1 i {'@'}Ses1 ile taklit eder.",
            promptMaxLength: 'İstem en fazla {count} karakter olabilir.',
            imageMaxCount: 'En fazla {count} referans görseli yükleyebilirsiniz.',
            videoDurationRange: 'Bu referans video {current} uzunluğunda. Lütfen {min} ile {max} saniye arasında bir video yükleyin.',
            videoMaxCount: 'En fazla {count} referans video yükleyebilirsiniz.',
            videoTotalDuration: 'Yükleme sonrası toplam video süresi {current} olacak ve {max} saniyelik sınırı aşacaktır.',
            audioDurationRange: 'Bu referans ses kaydı {current} uzunluğunda. Lütfen {min} ile {max} saniye arasında bir ses kaydı yükleyin.',
            audioMaxCount: 'En fazla {count} referans ses kaydı yükleyebilirsiniz.',
            audioTotalDuration: 'Yükleme sonrası toplam ses süresi {current} olacak ve {max} saniyelik sınırı aşacaktır.',
            mediaTotalDuration: 'Yükleme sonrası referans video ve seslerin toplam süresi {current} olacak ve {max} saniyelik sınırı aşacaktır.',
            audioNeedsVisualReference: 'Ses tek başına kullanılamaz. En az bir referans görsel veya referans video bırakın.',
            referenceRequired: 'En az bir referans görsel veya referans video yükleyin.',
            uploadHints: {
                image: '1-9 gorsel, en fazla 3 video ve en fazla 3 ses dosyasi desteklenir (her biri 2-15 sn; video ve ses toplam sureleri ayri hesaplanir, her biri <= 15 sn)',
                dance25: 'En fazla {imageCount} gorsel, {videoCount} video ve {audioCount} ses dosyasi desteklenir (her video/ses {minDuration}-{maxDuration} sn; video ve ses toplam sureleri ayri hesaplanir, her biri <= {totalDuration} sn)',
            },
        },
        uploadStrip: {
            removeVideo: 'Videoyu kaldır',
            removeImage: 'Görseli kaldır',
            removeAudio: 'Sesi kaldır',
        },
        toolTitles: {
            'video-motion-imitation': 'Yapay zekâ video hareket taklidi',
            'video-face-swap': 'Yapay zekâ video yüz değiştirme',
            'video-to-anime': 'Yapay zekâ video anime dönüştürücü',
            'video-subtitle-translate': 'Yapay zekâ altyazı çevirisi',
            'video-upscaler': 'Yapay zekâ video iyileştirme',
            'video-background-remover': 'Yapay zekâ video arka plan kaldırma',
            'video-watermark-remover': 'Yapay zekâ filigran kaldırıcı',
            'remove-video-subtitles': 'Yapay zekâ altyazı kaldırma',
            'video-extender': 'Yapay zekâ video uzatıcı',
            'image-background-changer': 'Yapay zekâ görsel arka plan değiştirici',
            'image-resizer': 'Yapay zekâ görsel yeniden boyutlandırıcı',
            'image-text-translate': 'Yapay zekâ görsel metin çevirisi',
            'image-upscaler': 'Yapay zekâ görsel kalite iyileştirme',
            'photo-face-swap': 'Yüz değiştirme',
            'remove-text-image': 'Yapay zekâ görsel metin silme',
            'ai-image-extender': 'Yapay zekâ görsel genişletme',
            'photo-restoration': 'Eski fotoğraf onarımı',
            'ai-image-background-remover': 'Yapay zekâ görsel arka plan kaldırıcı',
            'video-lip-sync': 'Yapay zekâ video dudak senkronizasyonu',
        },
        // Projelerim
        myProject: 'Projelerim',
        noProject: 'Proje yok',
        newProject: 'Yeni Proje',
        // Geçmiş hover işlemleri
        addToInput: 'Oluşturmaya ekle',
        reAdd: 'Yeniden ekle',
        imageEdit: 'Görsel düzenle',
        videoEdit: 'Video düzenle',
        videoToolCannotUploadImage: 'Video düzenleme araçları yalnızca video yükleyebilir, resim yükleyemez',
        videoEditOnlySupportVideo: 'Video düzenleme yalnızca video yüklemeyi destekler',
        videoAddedToTool: 'Video araca eklendi',
        switchedToImageMode: 'Görselden görsele moduna geçildi',
        switchedToVideoMode: 'Video düzenleme moduna geçildi',
        reEdit: 'Yeniden düzenle',
        musicCannotReEdit: 'Müzik yaratımı yeniden düzenlenemez',
    },
}
